/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(function () {
  'use strict';

  var MOBILE_BP = 749;
  var MOBILE_SLIDES = 3;
  var MOBILE_SCROLL = 3;

  function injectOverrideCSS() {
    if (document.getElementById('boost-sd-custom-override')) return;

    var style = document.createElement('style');
    style.id = 'boost-sd-custom-override';
    style.textContent = [

      'html body .boost-sd__recommendation .boost-sd__product-item,',
      'html body .boost-sd__recommendation .boost-sd__product-item.boost-sd__product-item--no-border {',
      '  background: #fff !important;',
      '  border: none !important;',
      '  border-radius: 0 !important;',
      '  overflow: visible !important;',
      '  box-shadow: none !important;',
      '  padding: 0 !important;',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-item-grid-view-layout-image {',
      '  aspect-ratio: 1/1 !important;',
      '  border: 1px solid #e8e8e8 !important;',
      '  border-radius: 8px !important;',
      '  overflow: visible !important;',
      '  background: #fff !important;',
      '  box-shadow: 0 1px 3px rgba(0,0,0,0.06) !important;',
      '  flex-shrink: 0 !important;',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '  position: relative !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-link-image {',
      '  flex: 1 1 100% !important;',
      '  min-height: 0 !important;',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '  overflow: hidden !important;',
      '  border-radius: 8px !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-image-wrapper {',
      '  background: #fff !important;',
      '  padding: 0 !important;',
      '  box-sizing: border-box !important;',
      '  flex: 1 !important;',
      '  min-height: 0 !important;',
      '  border-radius: 8px !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-image-img {',
      '  position: absolute !important;',
      '  top: 0 !important;',
      '  left: 0 !important;',
      '  width: 100% !important;',
      '  height: 100% !important;',
      '  object-fit: cover !important;',
      '  object-position: center center !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-title {',
      '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;',
      '  font-weight: 400 !important;',
      '  font-size: 13px !important;',
      '  line-height: 18px !important;',
      '  color: #333 !important;',
      '  display: -webkit-box !important;',
      '  -webkit-line-clamp: 2 !important;',
      '  -webkit-box-orient: vertical !important;',
      '  overflow: hidden !important;',
      '  text-overflow: ellipsis !important;',
      '  text-align: left !important;',
      '  white-space: normal !important;',
      '  word-break: break-word !important;',
      '  min-height: 36px !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-info-wrapper {',
      '  padding: 20px 4px 4px 4px !important;',
      '  flex-grow: 0 !important;',
      '  flex-shrink: 0 !important;',
      '}',
     /* Fiyat stilleri CSS dosyasında yönetiliyor - boost-sd-custom.css */
      /* Burada sadece temel layout ve renk kuralları */
      'html body .boost-sd__recommendation .boost-sd__product-price {',
      '  margin-top: 0 !important;',
      '  padding: 0 !important;',
      '  text-align: left !important;',
      '  width: 100% !important;',
      '}',

      /* --- Add-to-Cart Button - ÜST SAĞ KÖŞE --- */
      'html body .boost-sd__recommendation .boost-sd__button--select-option,',
      'html body .boost-sd__recommendation .boost-sd__button--select-option.boost-sd__button--circle,',
      'html body .boost-sd__recommendation .boost-sd__button--select-option.boost-sd__button--icon {',
      '  width: 38px !important;',
      '  height: 38px !important;',
      '  min-width: 38px !important;',
      '  min-height: 38px !important;',
      '  border-radius: 50% !important;',
      '  border: none !important;',
      '  background: #004125 !important;',
      '  display: inline-flex !important;',
      '  justify-content: center !important;',
      '  align-items: center !important;',
      '  cursor: pointer !important;',
      '  padding: 0 !important;',
      '  color: #000 !important;',
      '  box-shadow: 0 2px 6px rgba(0,65,37,0.3) !important;',
      '  position: absolute !important;',
      '  top: -10px !important;',
      '  right: -10px !important;',
      '  left: auto !important;',
      '  bottom: auto !important;',
      '  z-index: 10 !important;',
      '  margin: 0 !important;',
      '  text-align: center !important;',
      '  line-height: 1 !important;',
      '  font-size: 0 !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__button--select-option:hover {',
      '  background: #00331d !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon {',
      '  display: flex !important;',
      '  justify-content: center !important;',
      '  align-items: center !important;',
      '  width: 100% !important;',
      '  height: 100% !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  line-height: 0 !important;',
      '  position: absolute !important;',
      '  top: 0 !important;',
      '  left: 0 !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon svg {',
      '  width: 20px !important;',
      '  height: 20px !important;',
      '  fill: #000 !important;',
      '  display: block !important;',
      '  margin: 0 !important;',
      '  position: absolute !important;',
      '  top: 50% !important;',
      '  left: 50% !important;',
      '  transform: translate(-50%, -50%) !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__button--select-option > span:not(.boost-sd__icon) {',
      '  display: none !important;',
      '}',

      /* --- Discount Badge --- */
      'html body .boost-sd__recommendation .boost-sd__product-badge,',
      'html body .boost-sd__recommendation .boost-sd__product-image-column--left > * {',
      '  background: #e53935 !important;',
      '  color: #fff !important;',
      '  border-radius: 4px !important;',
      '  padding: 3px 8px !important;',
      '  font-weight: 600 !important;',
      '  font-size: 11px !important;',
      '}',

      /* --- Slider Navigation --- */
      'html body .boost-sd__recommendation .boost-sd__slider-button {',
      '  background: #fff !important;',
      '  border: 1px solid #e0e0e0 !important;',
      '  border-radius: 50% !important;',
      '  box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;',
      '  position: absolute !important;',
      '  top: -30% !important;',
      '  transform: translateY(-50%) !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '}',
      'html body .boost-sd__recommendation .boost-sd__slider-button * {',
      '  position: static !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  top: auto !important;',
      '  left: auto !important;',
      '  right: auto !important;',
      '  bottom: auto !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '}',
      'html body .boost-sd__recommendation .boost-sd__slider-button svg {',
      '  width: 20px !important;',
      '  height: 20px !important;',
      '  flex-shrink: 0 !important;',
      '}',
      'html body .boost-sd__recommendation .boost-sd__slider-button--next svg {',
      '  transform: rotate(-90deg) !important;',
      '}',
      'html body .boost-sd__recommendation .boost-sd__slider-button--prev svg {',
      '  transform: rotate(90deg) !important;',
      '}',

      'html body .boost-sd__recommendation .slick-dots,',
      'html body .boost-sd__recommendation [class*="slider-dots"],',
      'html body .boost-sd__recommendation [class*="slider-pagination"] {',
      '  display: none !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__slider {',
      '  overflow: visible !important;',
      '  position: relative !important;',
      '  padding: 15px 15px 0 0 !important;',
      '  margin: -15px -15px 0 0 !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__slide {',
      '  padding: 0 !important;',
      '  box-sizing: border-box !important;',
      '  overflow: visible !important;',
      '}',

      'html body .boost-sd__recommendation .slick-slide {',
      '  overflow: visible !important;',
      '}',

      'html body .boost-sd__recommendation .slick-list {',
      '  padding-top: 15px !important;',
      '  margin-top: -15px !important;',
      '}',

      'html body .boost-sd__recommendation .slick-track {',
      '  overflow: visible !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__recommendation-title-text,',
      'html body .boost-sd__recommendation [class*="recommendation-title-text"] {',
      '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;',
      '  font-weight: 600 !important;',
      '  font-size: 17px !important;',
      '  line-height: 22px !important;',
      '  color: #222 !important;',
      '  white-space: nowrap !important;',
      '  overflow: hidden !important;',
      '  text-overflow: ellipsis !important;',
      '  display: block !important;',
      '  max-width: 100% !important;',
      '  margin: 0 0 10px 0 !important;',
      '  padding: 10px !important;',
      '  word-break: normal !important;',
      '  text-align: left !important;',
      '}',

      'html body .boost-sd__recommendation [class*="recommendation-title"]::before,',
      'html body .boost-sd__recommendation [class*="recommendation-title"]::after {',
      '  display: none !important;',
      '  content: none !important;',
      '}',

      'html body .boost-sd__recommendation [class*="recommendation-title--"] {',
      '  text-align: left !important;',
      '  border: none !important;',
      '  display: block !important;',
      '  padding: 0 !important;',
      '  margin: 0 0 10px 0 !important;',
      '}',

      /* ===== MOBILE ===== */
      '@media (max-width: ' + MOBILE_BP + 'px) {',

        'html body .boost-sd__recommendation .boost-sd__recommendation-title-text,',
        'html body .boost-sd__recommendation [class*="recommendation-title-text"] {',
        '  font-size: 15px !important;',
        '  line-height: 20px !important;',
        '  margin-bottom: 8px !important;',
        '  padding: 1px !important;',
        '}',

        'html body .boost-sd__recommendation .slick-list {',
        '  overflow-x: auto !important;',
        '  overflow-y: visible !important;',
        '  -webkit-overflow-scrolling: touch !important;',
        '  scroll-snap-type: x mandatory !important;',
        '  scrollbar-width: none !important;',
        '  touch-action: pan-x pan-y !important;',
        '  overscroll-behavior-x: contain !important;',
        '  overscroll-behavior-y: auto !important;',
        '  scroll-padding-left: 0 !important;',
        '  scroll-behavior: smooth !important;',
        '  padding: 15px 15px 0 0 !important;',
        '  margin: -15px -15px 0 0 !important;',
        '}',

        'html body .boost-sd__recommendation .slick-slide {',
        '  overflow: visible !important;',
        '}',

        'html body .boost-sd__recommendation .slick-track {',
        '  overflow: visible !important;',
        '}',

        'html body .boost-sd__recommendation .slick-list::-webkit-scrollbar {',
        '  display: none !important;',
        '}',

        'html body .boost-sd__recommendation .slick-track {',
        '  transform: none !important;',
        '  -webkit-transform: none !important;',
        '  transition: none !important;',
        '  -webkit-transition: none !important;',
        '  width: auto !important;',
        '  max-width: none !important;',
        '  display: flex !important;',
        '  flex-wrap: nowrap !important;',
        '  will-change: auto !important;',
        '}',

        'html body .boost-sd__recommendation .slick-slide {',
        '  float: none !important;',
        '  flex-shrink: 0 !important;',
        '  scroll-snap-align: start !important;',
        '  scroll-snap-stop: always !important;',
        '  width: calc((100vw - 32px) / 3) !important;',
        '  box-sizing: border-box !important;',
        '  padding: 0 4px !important;',
        '}',

        'html body .boost-sd__recommendation .slick-slide:first-child {',
        '  padding-left: 0 !important;',
        '}',

        'html body .boost-sd__recommendation .slick-slide:not(.slick-cloned):last-of-type {',
        '  padding-right: 0 !important;',
        '}',

        'html body .boost-sd__recommendation .slick-slide.slick-cloned {',
        '  display: none !important;',
        '  width: 0 !important;',
        '  min-width: 0 !important;',
        '  max-width: 0 !important;',
        '  padding: 0 !important;',
        '  margin: 0 !important;',
        '  overflow: hidden !important;',
        '  visibility: hidden !important;',
        '  flex: 0 0 0 !important;',
        '  height: 0 !important;',
        '  opacity: 0 !important;',
        '  pointer-events: none !important;',
        '  position: absolute !important;',
        '  left: -9999px !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__slide {',
        '  padding: 0 !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-image-wrapper {',
        '  padding: 0 !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-info-wrapper {',
        '  padding: 4px !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-title {',
        '  font-size: 11px !important;',
        '  line-height: 15px !important;',
        '  min-height: 45px !important;',
        '  -webkit-line-clamp: 3 !important;',
        '  white-space: normal !important;',
        '}',

        /* Fiyat stilleri CSS dosyasında - boost-sd-custom.css */

        'html body .boost-sd__recommendation .boost-sd__button--select-option {',
        '  width: 34px !important;',
        '  height: 34px !important;',
        '  min-width: 34px !important;',
        '  min-height: 34px !important;',
        '  border-radius: 50% !important;',
        '  top: -10px !important;',
        '  right: -10px !important;',
        '  bottom: auto !important;',
        '  left: auto !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon svg {',
        '  width: 18px !important;',
        '  height: 18px !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-badge,',
        'html body .boost-sd__recommendation .boost-sd__product-image-column--left > * {',
        '  font-size: 8px !important;',
        '  padding: 2px 4px !important;',
        '}',

      '}',

      /* ===== Kucuk telefon ===== */
      '@media (max-width: 375px) {',
        'html body .boost-sd__recommendation .boost-sd__product-title {',
        '  font-size: 10px !important;',
        '  line-height: 14px !important;',
        '  min-height: 42px !important;',
        '  -webkit-line-clamp: 3 !important;',
        '  white-space: normal !important;',
        '}',
        /* Fiyat stilleri CSS dosyasında - boost-sd-custom.css */
        'html body .boost-sd__recommendation .boost-sd__product-info-wrapper {',
        '  padding: 4px !important;',
        '}',
        'html body .boost-sd__recommendation .boost-sd__product-image-wrapper {',
        '  padding: 0 !important;',
        '}',
        'html body .boost-sd__recommendation .boost-sd__button--select-option {',
        '  width: 30px !important;',
        '  height: 30px !important;',
        '  min-width: 30px !important;',
        '  min-height: 30px !important;',
        '  border-radius: 50% !important;',
        '  top: -8px !important;',
        '  right: -8px !important;',
        '  bottom: auto !important;',
        '  left: auto !important;',
        '}',
        'html body .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon svg {',
        '  width: 16px !important;',
        '  height: 16px !important;',
        '}',
      '}',

      /* ===== Desktop 750+ ===== */
      '@media (min-width: 750px) {',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__slide {',
        '  padding: 0 6px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__slide {',
        '  padding: 0 8px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-image-wrapper {',
        '  padding: 0 !important;',
        '  aspect-ratio: 4/5 !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-info-wrapper {',
        '  padding: 6px 10px 16px 10px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-title {',
        '  font-size: 14px!important;',
        '  line-height:  19px !important;',
        '  min-height: 57px !important;',
        '  -webkit-line-clamp: 3 !important;',
        '  display: -webkit-box !important;',
        '  -webkit-box-orient: vertical !important;',
        '  overflow: hidden !important;',
        '  text-overflow: ellipsis !important;',
        '  white-space: normal !important;',
        '}',
        /* Fiyat stilleri CSS dosyasında - boost-sd-custom.css */
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__button--select-option {',
        '  width: 46px !important;',
        '  height: 46px !important;',
        '  min-width: 46px !important;',
        '  min-height: 46px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon svg {',
        '  width: 22px !important;',
        '  height: 22px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-badge,',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-image-column--left > * {',
        '  font-size: 13px !important;',
        '  padding: 4px 10px !important;',
        '}',

        'html body .cart-page-content .shopify-section:has(.boost-sd__recommendation) {',
        '  overflow: hidden !important;',
        '}',

        'html body .cart-page-content .shopify-section:has(.boost-sd__recommendation):not(:has(.boost-sd__product-item)) {',
        '  display: none !important;',
        '  margin: 0 !important;',
        '  padding: 0 !important;',
        '  box-shadow: none !important;',
        '}',

        'html body .boost-sd__recommendation:not(:has(.boost-sd__product-item)) {',
        '  display: none !important;',
        '}',

        /* Fiyat stilleri CSS dosyasında - boost-sd-custom.css */
      '}',

      'html body .boost-sd__recommendation .insertedprimeb {',
      '  display: block !important;',
      '  visibility: visible !important;',
      '}',

      '@media (min-width: 750px) {',
        'html body .cart-page-content .shopify-section .boost-sd__recommendation {',
        '  overflow: hidden !important;',
        '}',

      '}',

      '/* Boost SD Check Icon - Beyaz tik ikonu */',
      'svg.boost-icon-check path {',
      '  fill: #fff !important;',
      '}'

    ].join('\n');

    document.body.appendChild(style);
  }

  function moveButtons() {
    document.querySelectorAll('.boost-sd__recommendation .boost-sd__product-item').forEach(function (item) {
      var btn = item.querySelector('.boost-sd__button--select-option');
      var imageArea = item.querySelector('.boost-sd__product-item-grid-view-layout-image');
      if (btn && imageArea && !imageArea.contains(btn)) {
        imageArea.appendChild(btn);
      }
    });
  }

  function equalizeCardHeights() {
    if (window.innerWidth > MOBILE_BP) return;

    document.querySelectorAll('.boost-sd__recommendation').forEach(function(rec) {
      var imageAreas = rec.querySelectorAll('.slick-slide:not(.slick-cloned) .boost-sd__product-item-grid-view-layout-image');
      if (imageAreas.length === 0) return;

      // Reset heights first
      imageAreas.forEach(function(area) {
        area.style.removeProperty('height');
        area.style.removeProperty('min-height');
        area.style.removeProperty('max-height');
      });

      // Force reflow
      void rec.offsetHeight;

      // Calculate height based on width (1:1 aspect ratio)
      // Get width from first area and apply as height to all
      var firstArea = imageAreas[0];
      if (!firstArea) return;

      var width = firstArea.getBoundingClientRect().width;

      // Apply width as height (1:1 aspect ratio) to all cards
      if (width > 50 && width < 500) {
        imageAreas.forEach(function(area) {
          area.style.setProperty('height', width + 'px', 'important');
          area.style.setProperty('min-height', width + 'px', 'important');
          area.style.setProperty('max-height', width + 'px', 'important');
        });
      }
    });
  }

  var lastViewportMode = null;

  function fixSliders() {
    var isDesktop = window.innerWidth > MOBILE_BP;
    var currentMode = isDesktop ? 'desktop' : 'mobile';
    var viewportChanged = lastViewportMode !== null && lastViewportMode !== currentMode;
    lastViewportMode = currentMode;

    if (isDesktop) {
      /* Tüm recommendation slider'lar için mobil stillerini temizle */
      document.querySelectorAll('.boost-sd__recommendation').forEach(function (rec) {
        /* Viewport değiştiyse veya mobil bayrakları varsa temizle */
        if (viewportChanged || rec.dataset.boostMobileStylesFixed || rec.dataset.boostMobileButtonsFixed) {
          delete rec.dataset.boostMobileStylesFixed;
          delete rec.dataset.boostSlickDisabled;
          delete rec.dataset.boostMobileButtonsFixed;
          delete rec.dataset.boostButtonsFixed;
          delete rec.dataset.boostDesktopStylesFixed;
          delete rec.dataset.boostInfiniteLoop;
          var slickEl = rec.querySelector('.slick-initialized');
          if (slickEl) delete slickEl.dataset.boostSlidersFixed;

          var track = rec.querySelector('.slick-track');
          if (track) {
            /* MutationObserver'ı durdur */
            if (track._boostTrackObserver) {
              track._boostTrackObserver.disconnect();
              delete track._boostTrackObserver;
            }
            /* Infinite loop klonlarını temizle */
            track.querySelectorAll('.boost-infinite-clone').forEach(function(c) { c.remove(); });
            track.style.cssText = '';
          }

          /* Tüm slide'ların ve içeriklerinin inline stillerini temizle */
          rec.querySelectorAll('.slick-slide').forEach(function(slide) {
            slide.style.cssText = '';
            /* Slide içindeki ana elementleri de temizle */
            var productItem = slide.querySelector('.boost-sd__product-item');
            if (productItem) productItem.style.cssText = '';
            var imageWrapper = slide.querySelector('.boost-sd__product-image-wrapper');
            if (imageWrapper) imageWrapper.style.cssText = '';
            var imageLayout = slide.querySelector('.boost-sd__product-item-grid-view-layout-image');
            if (imageLayout) {
              /* equalizeCardHeights'ın eklediği inline height değerlerini temizle */
              imageLayout.style.removeProperty('height');
              imageLayout.style.removeProperty('min-height');
              imageLayout.style.removeProperty('max-height');
              imageLayout.style.cssText = '';
            }
          });

          var slickList = rec.querySelector('.slick-list');
          if (slickList) {
            slickList.style.cssText = '';
            delete slickList.dataset.boostTouchFixed;
            delete slickList.dataset.boostDesktopScrollSnap;
          }

          /* Force layout recalculation */
          void rec.offsetWidth;

          /* Slick slider'ı yeniden başlat ve mobilde devre dışı bırakılan seçenekleri geri aç */
          var slickEl = rec.querySelector('.slick-initialized');
          if (slickEl && window.jQuery) {
            try {
              var $slick = jQuery(slickEl);
              var slickInstance = $slick.slick('getSlick');

              $slick.slick('slickSetOption', 'swipe', true, false);
              $slick.slick('slickSetOption', 'touchMove', true, false);
              $slick.slick('slickSetOption', 'draggable', true, false);
              $slick.slick('slickSetOption', 'infinite', true, false);
              $slick.slick('slickSetOption', 'accessibility', true, false);

              if (slickInstance) {
                slickInstance.slideWidth = null;
                slickInstance.listWidth = null;
              }

              $slick.slick('setPosition');

              setTimeout(function() {
                if (slickInstance) {
                  slickInstance.slideWidth = null;
                  slickInstance.listWidth = null;
                }
                $slick.slick('setPosition');
              }, 100);
            } catch (e) {}
          }
        }
      });

      document.querySelectorAll('.boost-sd__recommendation').forEach(function (rec) {
        if (rec.closest('.cart-page-content')) {
          var section = rec.closest('.shopify-section');
          if (section) {
            section.style.setProperty('overflow', 'hidden', 'important');
          }
        }
        return;

        var track = rec.querySelector('.slick-track');
        var slickList = rec.querySelector('.slick-list');

        rec.querySelectorAll('.slick-slide.slick-cloned').forEach(function(clone) {
          clone.style.cssText = 'display: none !important; width: 0 !important; min-width: 0 !important; ' +
            'max-width: 0 !important; height: 0 !important; padding: 0 !important; margin: 0 !important; ' +
            'flex: 0 0 0 !important; visibility: hidden !important; opacity: 0 !important; ' +
            'position: absolute !important; left: -9999px !important; pointer-events: none !important;';
        });

        var slickEl = rec.querySelector('.slick-initialized');
        if (slickEl && window.jQuery && !rec.dataset.boostSlickDisabled) {
          rec.dataset.boostSlickDisabled = 'true';
          try {
            var $slick = jQuery(slickEl);
            $slick.slick('slickSetOption', 'swipe', false, false);
            $slick.slick('slickSetOption', 'touchMove', false, false);
            $slick.slick('slickSetOption', 'draggable', false, false);
            $slick.slick('slickSetOption', 'infinite', false, false);
            $slick.slick('slickSetOption', 'accessibility', false, false);
          } catch (e) {}

          if (track && !track._boostTrackObserver) {
            var resetTrackStyles = function() {
              if (track.style.transform && track.style.transform !== 'none') {
                var tw = track._boostExpectedWidth;
                if (tw > 0) {
                  track.style.cssText = 'transform: none !important; -webkit-transform: none !important; ' +
                    'transition: none !important; -webkit-transition: none !important; ' +
                    'width: ' + tw + 'px !important; max-width: ' + tw + 'px !important; ' +
                    'min-width: ' + tw + 'px !important; ' +
                    'display: flex !important; flex-wrap: nowrap !important; will-change: auto !important; ' +
                    'overflow: visible !important;';
                } else {
                  track.style.transform = 'none';
                }
              }
            };
            var trackObserver = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'style') {
                  resetTrackStyles();
                }
              });
            });
            trackObserver.observe(track, { attributes: true, attributeFilter: ['style'] });
            track._boostTrackObserver = trackObserver;
          }
        }

        var realSlides = rec.querySelectorAll('.slick-slide:not(.slick-cloned):not(.boost-infinite-clone)');
        var realSlideCount = realSlides.length;
        var slidesToShow = 4;
        if (slickEl && window.jQuery) {
          try {
            var inst = jQuery(slickEl).slick('getSlick');
            slidesToShow = inst.options.slidesToShow || 4;
          } catch (e) {}
        }

        var containerEl = slickList || rec;
        var containerWidth = containerEl.getBoundingClientRect().width;
        if (containerWidth < 100) containerWidth = rec.getBoundingClientRect().width;
        if (containerWidth < 100) containerWidth = 800;
        if (slickList && containerWidth > 100) {
          var slCS = window.getComputedStyle(slickList);
          var padLR = (parseFloat(slCS.paddingLeft) || 0) + (parseFloat(slCS.paddingRight) || 0);
          if (padLR > 0 && padLR < containerWidth * 0.5) {
            containerWidth -= padLR;
          }
        }
        var singleSlideWidth = containerWidth / slidesToShow;
        var trackWidth = singleSlideWidth * realSlideCount;

        if (track && realSlideCount > 0) {
          track.style.cssText = 'transform: none !important; -webkit-transform: none !important; ' +
            'transition: none !important; -webkit-transition: none !important; ' +
            'width: ' + trackWidth + 'px !important; max-width: ' + trackWidth + 'px !important; ' +
            'min-width: ' + trackWidth + 'px !important; ' +
            'display: flex !important; flex-wrap: nowrap !important; will-change: auto !important; ' +
            'overflow: visible !important; gap: 0 !important; margin: 0 !important; padding: 0 !important;';
        }

        if (track) {
          track._boostExpectedWidth = trackWidth;
        }

        if (slickList) {
          slickList.style.setProperty('overflow-x', 'auto', 'important');
          slickList.style.setProperty('overflow-y', 'clip', 'important');
          slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
          slickList.style.setProperty('scroll-behavior', 'smooth', 'important');
          slickList.style.setProperty('scrollbar-width', 'none', 'important');
          slickList.style.setProperty('-ms-overflow-style', 'none', 'important');
          slickList.style.setProperty('overscroll-behavior-x', 'contain', 'important');
          slickList.style.setProperty('padding', '15px 15px 0 0', 'important');
          slickList.style.setProperty('margin', '-15px -15px 0 0', 'important');
        }

        if (rec.dataset.boostDesktopStylesFixed) {
          /* Track ve slickList stilleri her çağrıda güncelleniyor (yukarıda), slide stilleri bir kez */
        } else {
          var allSlides = rec.querySelectorAll('.slick-slide');
          if (allSlides.length > 0) {
            var realIndex = 0;
            allSlides.forEach(function (s) {
              if (s.classList.contains('slick-cloned')) {
                return;
              }
              s.style.setProperty('width', singleSlideWidth + 'px', 'important');
              s.style.setProperty('float', 'none', 'important');
              s.style.setProperty('flex-shrink', '0', 'important');
              s.style.setProperty('scroll-snap-align', 'start', 'important');
              s.style.setProperty('scroll-snap-stop', 'always', 'important');
              s.style.setProperty('box-sizing', 'border-box', 'important');
              s.style.setProperty('overflow', 'visible', 'important');
              s.style.setProperty('padding', '0', 'important');
              s.style.setProperty('margin', '0', 'important');
              // İç boost-sd__slide elementinin padding'ini de sıfırla
              var innerSlide = s.querySelector('.boost-sd__slide');
              if (innerSlide) {
                innerSlide.style.setProperty('padding', '0', 'important');
                innerSlide.style.setProperty('margin', '0', 'important');
              }
              realIndex++;
            });
            rec.dataset.boostDesktopStylesFixed = 'true';

            rec.querySelectorAll('.boost-sd__product-item').forEach(function(item) {
              var addBtn = item.querySelector('.boost-sd__button--select-option');
              if (addBtn && !addBtn.dataset.boostBtnMoved) {
                addBtn.dataset.boostBtnMoved = 'true';
                item.appendChild(addBtn);
              }
            });
          }
        }

        if (slickList && !rec.dataset.boostButtonsFixed) {
          var scrollAmount = singleSlideWidth * 2;

          var isScrolling = false;
          var scrollDebounceTime = 400;
          var buttonsSetup = 0;

          rec.querySelectorAll('.boost-sd__slider-button').forEach(function (btn) {
            var clone = btn.cloneNode(true);
            btn.parentNode.replaceChild(clone, btn);
            buttonsSetup++;

            var isPrev = false;
            if (clone.classList.contains('boost-sd__slider-button--prev')) isPrev = true;
            if (clone.querySelector('.boost-sd__icon--arrow-left')) isPrev = true;
            if (clone.querySelector('[class*="left"]')) isPrev = true;
            if (clone.querySelector('[class*="prev"]')) isPrev = true;
            var ariaLabel = (clone.getAttribute('aria-label') || '').toLowerCase();
            if (ariaLabel.includes('prev') || ariaLabel.includes('önceki') || ariaLabel.includes('geri')) isPrev = true;

            var isNext = false;
            if (clone.classList.contains('boost-sd__slider-button--next')) isNext = true;
            if (clone.querySelector('.boost-sd__icon--arrow-right')) isNext = true;
            if (clone.querySelector('[class*="right"]')) isNext = true;
            if (clone.querySelector('[class*="next"]')) isNext = true;
            if (ariaLabel.includes('next') || ariaLabel.includes('sonraki') || ariaLabel.includes('ileri')) isNext = true;

            if (!isPrev && !isNext) {
              var allBtns = rec.querySelectorAll('.boost-sd__slider-button');
              var idx = Array.prototype.indexOf.call(allBtns, clone);
              isPrev = idx === 0;
              isNext = idx > 0;
            }

            clone.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              if (isScrolling) return;

              var currentScroll = slickList.scrollLeft;
              var maxScroll = slickList.scrollWidth - slickList.clientWidth;
              var padR = parseFloat(window.getComputedStyle(slickList).paddingRight) || 0;
              if (padR > 0) maxScroll = Math.max(0, maxScroll - padR);
              var tolerance = 5;

              if (isPrev && currentScroll <= tolerance) return;
              if (isNext && currentScroll >= maxScroll - tolerance) return;

              isScrolling = true;
              var direction = isPrev ? -scrollAmount : scrollAmount;
              slickList.scrollBy({
                left: direction,
                behavior: 'smooth'
              });

              setTimeout(function() {
                isScrolling = false;
              }, scrollDebounceTime);
            });
          });

          if (buttonsSetup > 0) {
            rec.dataset.boostButtonsFixed = 'true';
          }
        }
      });
      return;
    }

    var slideW = 'calc((100vw - 32px) / 3)';

    document.querySelectorAll('.boost-sd__recommendation').forEach(function (rec) {
      /* Masaüstünden mobile geçişte desktop bayraklarını temizle */
      if (viewportChanged || (rec.dataset.boostButtonsFixed && !rec.dataset.boostMobileButtonsFixed)) {
        delete rec.dataset.boostButtonsFixed;
        delete rec.dataset.boostSlidersFixed;
        delete rec.dataset.boostMobileButtonsFixed;
        delete rec.dataset.boostMobileStylesFixed;
        delete rec.dataset.boostSlickDisabled;
        delete rec.dataset.boostDesktopStylesFixed;
        delete rec.dataset.boostInfiniteLoop;
        var tempSlickList = rec.querySelector('.slick-list');
        if (tempSlickList) {
          delete tempSlickList.dataset.boostDesktopScrollSnap;
          delete tempSlickList.dataset.boostTouchFixed;
        }
        var slickEl = rec.querySelector('.slick-initialized');
        if (slickEl) delete slickEl.dataset.boostSlidersFixed;
        // Infinite loop klonlarını temizle
        var tempTrack = rec.querySelector('.slick-track');
        if (tempTrack) {
          tempTrack.querySelectorAll('.boost-infinite-clone').forEach(function(c) { c.remove(); });
        }
      }

      var track = rec.querySelector('.slick-track');
      var slickList = rec.querySelector('.slick-list');

      // Cloned slide'ları gizle (her çalışmada)
      var clonedSlides = rec.querySelectorAll('.slick-slide.slick-cloned');
      clonedSlides.forEach(function(clone) {
        clone.style.cssText = 'display: none !important; width: 0 !important; min-width: 0 !important; ' +
          'max-width: 0 !important; height: 0 !important; padding: 0 !important; margin: 0 !important; ' +
          'flex: 0 0 0 !important; visibility: hidden !important; opacity: 0 !important; ' +
          'position: absolute !important; left: -9999px !important; pointer-events: none !important;';
      });

      var slickEl = rec.querySelector('.slick-initialized');
      if (slickEl && window.jQuery && !rec.dataset.boostSlickDisabled) {
        rec.dataset.boostSlickDisabled = 'true';
        try {
          var $slick = jQuery(slickEl);
          $slick.slick('slickSetOption', 'swipe', false, false);
          $slick.slick('slickSetOption', 'touchMove', false, false);
          $slick.slick('slickSetOption', 'draggable', false, false);
          $slick.slick('slickSetOption', 'infinite', false, false);
          $slick.slick('slickSetOption', 'accessibility', false, false);
        } catch (e) {}

        if (slickList && !slickList.dataset.boostTouchFixed) {
          slickList.dataset.boostTouchFixed = 'true';

          var touchStartX = 0;
          var touchStartY = 0;
          var isHorizontalScroll = false;

          var handleTouchStart = function(e) {
            if (e.touches && e.touches.length > 0) {
              touchStartX = e.touches[0].clientX;
              touchStartY = e.touches[0].clientY;
              isHorizontalScroll = false;
            }
          };

          var handleTouchMove = function(e) {
            if (e.touches && e.touches.length > 0) {
              var deltaX = Math.abs(e.touches[0].clientX - touchStartX);
              var deltaY = Math.abs(e.touches[0].clientY - touchStartY);

              // Sadece yatay scroll ise propagation'ı durdur, dikey scroll'a izin ver
              if (deltaX > deltaY && deltaX > 10) {
                isHorizontalScroll = true;
                e.stopPropagation();
              }
            }
          };

          var handleTouchEnd = function(e) {
            if (isHorizontalScroll) {
              e.stopPropagation();
            }
            isHorizontalScroll = false;
          };

          slickList.addEventListener('touchstart', handleTouchStart, { capture: true, passive: true });
          slickList.addEventListener('touchmove', handleTouchMove, { capture: true, passive: true });
          slickList.addEventListener('touchend', handleTouchEnd, { capture: true, passive: true });

          if (track) {
            var resetTransform = function() {
              if (track.style.transform && track.style.transform !== 'none') {
                track.style.transform = 'none';
              }
            };
            var trackObserver = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'style') {
                  resetTransform();
                }
              });
            });
            trackObserver.observe(track, { attributes: true, attributeFilter: ['style'] });
            /* Observer'ı track üzerinde sakla - masaüstüne geçişte disconnect için */
            track._boostTrackObserver = trackObserver;
          }
        }
      }

      var realSlides = rec.querySelectorAll('.slick-slide:not(.slick-cloned):not(.boost-infinite-clone)');
      var realSlideCount = realSlides.length;
      var containerWidth = window.innerWidth - 32;
      var singleSlideWidth = containerWidth / 3;
      // Infinite loop aktifse track width klonları da içermeli
      var infiniteClones = rec.querySelectorAll('.boost-infinite-clone');
      var totalSlideCount = realSlideCount + infiniteClones.length;
      var trackWidth = singleSlideWidth * (rec.dataset.boostInfiniteLoop ? totalSlideCount : realSlideCount);

      if (track && realSlideCount > 0) {
        track.style.cssText = 'transform: none !important; -webkit-transform: none !important; ' +
          'transition: none !important; -webkit-transition: none !important; ' +
          'width: ' + trackWidth + 'px !important; max-width: ' + trackWidth + 'px !important; ' +
          'min-width: ' + trackWidth + 'px !important; ' +
          'display: flex !important; flex-wrap: nowrap !important; will-change: auto !important; ' +
          'overflow: visible !important;';
      }

      if (slickList) {
        slickList.style.setProperty('overflow-x', 'auto', 'important');
        slickList.style.setProperty('overflow-y', 'clip', 'important');
        slickList.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
        slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
        slickList.style.setProperty('touch-action', 'pan-x pan-y', 'important');
        slickList.style.setProperty('overscroll-behavior-x', 'contain', 'important');
        slickList.style.setProperty('overscroll-behavior-y', 'auto', 'important');
        slickList.style.setProperty('scroll-padding-left', '0', 'important');
        slickList.style.setProperty('scroll-behavior', 'smooth', 'important');
        slickList.style.setProperty('padding', '15px 15px 0 0', 'important');
        slickList.style.setProperty('margin', '-15px -15px 0 0', 'important');
      }

      if (rec.dataset.boostMobileStylesFixed) return;

      var allSlides = rec.querySelectorAll('.slick-slide');
      if (allSlides.length > 0) {
        var realIndex = 0;
        allSlides.forEach(function (s) {
          if (s.classList.contains('slick-cloned')) {
            s.style.setProperty('display', 'none', 'important');
            s.style.setProperty('width', '0', 'important');
            s.style.setProperty('min-width', '0', 'important');
            s.style.setProperty('max-width', '0', 'important');
            s.style.setProperty('padding', '0', 'important');
            s.style.setProperty('margin', '0', 'important');
            s.style.setProperty('flex', '0 0 0', 'important');
            s.style.setProperty('visibility', 'hidden', 'important');
            s.style.setProperty('overflow', 'hidden', 'important');
            return;
          }
          s.style.setProperty('width', slideW, 'important');
          s.style.setProperty('float', 'none', 'important');
          s.style.setProperty('flex-shrink', '0', 'important');
          s.style.setProperty('scroll-snap-align', 'start', 'important');
          s.style.setProperty('scroll-snap-stop', 'always', 'important');
          s.style.setProperty('box-sizing', 'border-box', 'important');
          s.style.setProperty('padding', '0 4px', 'important');
          if (realIndex === 0) {
            s.style.setProperty('padding-left', '0', 'important');
          }
          if (realIndex === realSlideCount - 1) {
            s.style.setProperty('padding-right', '0', 'important');
          }
          realIndex++;
        });
        rec.dataset.boostMobileStylesFixed = 'true';

        rec.querySelectorAll('.boost-sd__product-item').forEach(function(item) {
          var addBtn = item.querySelector('.boost-sd__button--select-option');
          if (addBtn && !addBtn.dataset.boostBtnMoved) {
            addBtn.dataset.boostBtnMoved = 'true';
            item.appendChild(addBtn);
          }
        });
      }

      if (slickList && !rec.dataset.boostMobileButtonsFixed) {
        var containerWidth = window.innerWidth - 32;
        var singleSlideW = containerWidth / 3;
        var scrollAmount = singleSlideW * 2;

        var isScrolling = false;
        var scrollDebounceTime = 350;
        var mobileBtnsFound = 0;

        rec.querySelectorAll('.boost-sd__slider-button').forEach(function (btn) {
          var clone = btn.cloneNode(true);
          btn.parentNode.replaceChild(clone, btn);
          mobileBtnsFound++;

          var isPrev = false;
          if (clone.classList.contains('boost-sd__slider-button--prev')) isPrev = true;
          if (clone.querySelector('.boost-sd__icon--arrow-left')) isPrev = true;
          if (clone.querySelector('[class*="left"]')) isPrev = true;
          if (clone.querySelector('[class*="prev"]')) isPrev = true;
          var ariaLabel = (clone.getAttribute('aria-label') || '').toLowerCase();
          if (ariaLabel.includes('prev') || ariaLabel.includes('önceki') || ariaLabel.includes('geri')) isPrev = true;

          var isNext = false;
          if (clone.classList.contains('boost-sd__slider-button--next')) isNext = true;
          if (clone.querySelector('.boost-sd__icon--arrow-right')) isNext = true;
          if (clone.querySelector('[class*="right"]')) isNext = true;
          if (clone.querySelector('[class*="next"]')) isNext = true;
          if (ariaLabel.includes('next') || ariaLabel.includes('sonraki') || ariaLabel.includes('ileri')) isNext = true;

          if (!isPrev && !isNext) {
            var allBtns = rec.querySelectorAll('.boost-sd__slider-button');
            var idx = Array.prototype.indexOf.call(allBtns, clone);
            isPrev = idx === 0;
            isNext = idx > 0;
          }

          clone.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (isScrolling) return;

            var currentScroll = slickList.scrollLeft;
            var maxScroll = slickList.scrollWidth - slickList.clientWidth;
            var tolerance = 5;

            if (isPrev && currentScroll <= tolerance) return;
            if (isNext && currentScroll >= maxScroll - tolerance) return;

            isScrolling = true;
            var direction = isPrev ? -scrollAmount : scrollAmount;
            slickList.scrollBy({
              left: direction,
              behavior: 'smooth'
            });

            setTimeout(function() {
              isScrolling = false;
            }, scrollDebounceTime);
          });
        });

        if (mobileBtnsFound > 0) {
          rec.dataset.boostMobileButtonsFixed = 'true';
        }
      }

      // Infinite loop setup for mobile
      if (slickList && track && !rec.dataset.boostInfiniteLoop) {
        var realSlidesForLoop = Array.from(rec.querySelectorAll('.slick-slide:not(.slick-cloned):not(.boost-infinite-clone)'));
        if (realSlidesForLoop.length >= 3) {
          rec.dataset.boostInfiniteLoop = 'true';

          var slideWidth = (window.innerWidth - 32) / 3;
          var cloneCount = 3; // Görünür kart sayısı kadar klon

          // Önceki klonları temizle
          track.querySelectorAll('.boost-infinite-clone').forEach(function(c) { c.remove(); });

          // Son slide'ların klonlarını başa ekle (ters sırada - son, sondan bir önceki, ...)
          var startCloneIndex = 0;
          for (var i = realSlidesForLoop.length - 1; i >= realSlidesForLoop.length - cloneCount; i--) {
            var cloneStart = realSlidesForLoop[i].cloneNode(true);
            cloneStart.classList.add('boost-infinite-clone', 'boost-clone-start');
            cloneStart.classList.remove('slick-active', 'slick-current');
            cloneStart.style.setProperty('width', slideWidth + 'px', 'important');
            cloneStart.style.setProperty('flex-shrink', '0', 'important');
            cloneStart.style.setProperty('scroll-snap-align', 'start', 'important');
            cloneStart.style.setProperty('padding', '0 4px', 'important');
            cloneStart.style.setProperty('box-sizing', 'border-box', 'important');
            track.insertBefore(cloneStart, track.firstChild);
            startCloneIndex++;
          }

          // İlk slide'ların klonlarını sona ekle
          for (var j = 0; j < cloneCount; j++) {
            var cloneEnd = realSlidesForLoop[j].cloneNode(true);
            cloneEnd.classList.add('boost-infinite-clone', 'boost-clone-end');
            cloneEnd.classList.remove('slick-active', 'slick-current');
            cloneEnd.style.setProperty('width', slideWidth + 'px', 'important');
            cloneEnd.style.setProperty('flex-shrink', '0', 'important');
            cloneEnd.style.setProperty('scroll-snap-align', 'start', 'important');
            cloneEnd.style.setProperty('padding', '0 4px', 'important');
            cloneEnd.style.setProperty('box-sizing', 'border-box', 'important');
            track.appendChild(cloneEnd);
          }

          // Track genişliğini güncelle
          var totalSlides = realSlidesForLoop.length + (cloneCount * 2);
          var newTrackWidth = slideWidth * totalSlides;
          track.style.setProperty('width', newTrackWidth + 'px', 'important');
          track.style.setProperty('max-width', newTrackWidth + 'px', 'important');
          track.style.setProperty('min-width', newTrackWidth + 'px', 'important');

          // Başlangıç pozisyonu
          var startPosition = slideWidth * cloneCount;

          // Slick'in event listener'larını kaldır - slick-list'i klonla
          var slickListClone = slickList.cloneNode(false);
          while (slickList.firstChild) {
            slickListClone.appendChild(slickList.firstChild);
          }
          slickList.parentNode.replaceChild(slickListClone, slickList);
          slickList = slickListClone;

          // Scroll özellikleri
          slickList.style.setProperty('overflow-x', 'auto', 'important');
          slickList.style.setProperty('overflow-y', 'clip', 'important');
          slickList.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
          slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
          slickList.style.setProperty('touch-action', 'pan-x pan-y', 'important');
          slickList.style.setProperty('overscroll-behavior-x', 'contain', 'important');
          slickList.style.setProperty('scrollbar-width', 'none', 'important');
          slickList.style.setProperty('scroll-behavior', 'auto', 'important');
          slickList.scrollLeft = startPosition;

          requestAnimationFrame(function() {
            slickList.style.setProperty('scroll-behavior', 'smooth', 'important');
          });

          // Scroll event ile infinite loop kontrolü
          var isJumping = false;
          var realContentStart = slideWidth * cloneCount;
          var realContentEnd = realContentStart + (slideWidth * realSlidesForLoop.length);

          var handleInfiniteScroll = function() {
            if (isJumping) return;

            var scrollLeft = slickList.scrollLeft;

            // Son klonlara ulaştıysa
            if (scrollLeft >= realContentEnd - (slideWidth * 2)) {
              isJumping = true;
              var offset = scrollLeft - realContentEnd + slideWidth;
              slickList.style.setProperty('scroll-behavior', 'auto', 'important');
              slickList.style.setProperty('scroll-snap-type', 'none', 'important');
              slickList.scrollLeft = realContentStart + offset;
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  slickList.style.setProperty('scroll-behavior', 'smooth', 'important');
                  slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
                  isJumping = false;
                });
              });
            }
            // Başlangıç klonlarına ulaştıysa
            else if (scrollLeft <= slideWidth) {
              isJumping = true;
              var offset = realContentStart - scrollLeft;
              slickList.style.setProperty('scroll-behavior', 'auto', 'important');
              slickList.style.setProperty('scroll-snap-type', 'none', 'important');
              slickList.scrollLeft = realContentEnd - slideWidth - offset;
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  slickList.style.setProperty('scroll-behavior', 'smooth', 'important');
                  slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
                  isJumping = false;
                });
              });
            }
          };

          // Touch event handler
          var infTouchStartX = 0;
          var infIsTouchScrolling = false;

          slickList.addEventListener('touchstart', function(e) {
            if (e.touches && e.touches.length > 0) {
              infTouchStartX = e.touches[0].clientX;
              infIsTouchScrolling = false;
            }
          }, { passive: true, capture: true });

          slickList.addEventListener('touchmove', function(e) {
            if (e.touches && e.touches.length > 0) {
              var deltaX = Math.abs(e.touches[0].clientX - infTouchStartX);
              if (deltaX > 10) {
                infIsTouchScrolling = true;
              }
            }
          }, { passive: true, capture: true });

          // Scroll event
          var scrollEndTimer = null;
          var infLastScrollLeft = slickList.scrollLeft;

          slickList.addEventListener('scroll', function() {
            infLastScrollLeft = slickList.scrollLeft;
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(handleInfiniteScroll, 100);
          }, { passive: true });

          // Touch end
          slickList.addEventListener('touchend', function() {
            if (infIsTouchScrolling) {
              clearTimeout(scrollEndTimer);
              var checkEnd = function() {
                var curr = slickList.scrollLeft;
                if (Math.abs(curr - infLastScrollLeft) < 1) {
                  handleInfiniteScroll();
                } else {
                  infLastScrollLeft = curr;
                  setTimeout(checkEnd, 50);
                }
              };
              setTimeout(checkEnd, 100);
            }
            infIsTouchScrolling = false;
          }, { passive: true });
        }
      }

    });

    // Cart page section'ları için özel infinite loop kontrolü (cartpage-686707, cartpage-887768)
    document.querySelectorAll('[id*="cartpage-686707"], [id*="cartpage-887768"]').forEach(function(wrapper) {
      var rec = wrapper.querySelector('.boost-sd__recommendation') || wrapper.closest('.boost-sd__recommendation');
      if (!rec) {
        // Belki wrapper kendisi recommendation
        if (wrapper.classList && wrapper.classList.contains('boost-sd__recommendation')) {
          rec = wrapper;
        }
      }
      if (!rec) return;

      var track = rec.querySelector('.slick-track') || wrapper.querySelector('.slick-track');
      var slickList = rec.querySelector('.slick-list') || wrapper.querySelector('.slick-list');

      if (!slickList || !track) return;
      if (rec.dataset.boostInfiniteLoop) return;

      var realSlidesForCart = Array.from((track.closest('.slick-slider') || track.parentElement).querySelectorAll('.slick-slide:not(.slick-cloned):not(.boost-infinite-clone)'));
      if (realSlidesForCart.length < 3) return;

      rec.dataset.boostInfiniteLoop = 'true';

      // Slick slider'ın mobil davranışını devre dışı bırak
      var slickEl = wrapper.querySelector('.slick-initialized') || rec.querySelector('.slick-initialized');
      if (slickEl && window.jQuery) {
        try {
          var $slick = jQuery(slickEl);
          $slick.slick('slickSetOption', 'swipe', false, false);
          $slick.slick('slickSetOption', 'touchMove', false, false);
          $slick.slick('slickSetOption', 'draggable', false, false);
          $slick.slick('slickSetOption', 'infinite', false, false);
          $slick.slick('slickSetOption', 'accessibility', false, false);
        } catch (e) {}
      }

      // MutationObserver ile track transform'unu sürekli sıfırla
      var resetCartTrack = function() {
        if (track.style.transform && track.style.transform !== 'none') {
          track.style.transform = 'none';
          track.style.transition = 'none';
        }
      };
      var cartTrackObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'style') {
            resetCartTrack();
          }
        });
      });
      cartTrackObserver.observe(track, { attributes: true, attributeFilter: ['style'] });
      track._boostCartTrackObserver = cartTrackObserver;

      // slick-list'e scroll özellikleri ekle
      slickList.style.setProperty('overflow-x', 'auto', 'important');
      slickList.style.setProperty('overflow-y', 'clip', 'important');
      slickList.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
      slickList.style.setProperty('touch-action', 'pan-x pan-y', 'important');
      slickList.style.setProperty('overscroll-behavior-x', 'contain', 'important');
      slickList.style.setProperty('scrollbar-width', 'none', 'important');

      // Track'e flex özellikleri ekle
      track.style.setProperty('display', 'flex', 'important');
      track.style.setProperty('flex-wrap', 'nowrap', 'important');
      track.style.setProperty('transform', 'none', 'important');
      track.style.setProperty('transition', 'none', 'important');

      var slideWidth = (window.innerWidth - 32) / 3;
      var cloneCount = 3;

      // Gerçek slide'lara stil ekle
      realSlidesForCart.forEach(function(slide) {
        slide.style.setProperty('width', slideWidth + 'px', 'important');
        slide.style.setProperty('flex-shrink', '0', 'important');
        slide.style.setProperty('scroll-snap-align', 'start', 'important');
        slide.style.setProperty('padding', '0 4px', 'important');
        slide.style.setProperty('box-sizing', 'border-box', 'important');
        slide.style.setProperty('float', 'none', 'important');
      });

      // Slick cloned slide'ları gizle
      track.querySelectorAll('.slick-slide.slick-cloned').forEach(function(clone) {
        clone.style.cssText = 'display: none !important; width: 0 !important; min-width: 0 !important; ' +
          'max-width: 0 !important; padding: 0 !important; margin: 0 !important; ' +
          'flex: 0 0 0 !important; visibility: hidden !important;';
      });

      // Önceki infinite loop klonlarını temizle
      track.querySelectorAll('.boost-infinite-clone').forEach(function(c) { c.remove(); });

      // Son slide'ların klonlarını başa ekle
      for (var i = realSlidesForCart.length - 1; i >= realSlidesForCart.length - cloneCount; i--) {
        var cloneStart = realSlidesForCart[i].cloneNode(true);
        cloneStart.classList.add('boost-infinite-clone', 'boost-clone-start');
        cloneStart.classList.remove('slick-active', 'slick-current');
        cloneStart.style.setProperty('width', slideWidth + 'px', 'important');
        cloneStart.style.setProperty('flex-shrink', '0', 'important');
        cloneStart.style.setProperty('scroll-snap-align', 'start', 'important');
        cloneStart.style.setProperty('padding', '0 4px', 'important');
        cloneStart.style.setProperty('box-sizing', 'border-box', 'important');
        track.insertBefore(cloneStart, track.firstChild);
      }

      // İlk slide'ların klonlarını sona ekle
      for (var j = 0; j < cloneCount; j++) {
        var cloneEnd = realSlidesForCart[j].cloneNode(true);
        cloneEnd.classList.add('boost-infinite-clone', 'boost-clone-end');
        cloneEnd.classList.remove('slick-active', 'slick-current');
        cloneEnd.style.setProperty('width', slideWidth + 'px', 'important');
        cloneEnd.style.setProperty('flex-shrink', '0', 'important');
        cloneEnd.style.setProperty('scroll-snap-align', 'start', 'important');
        cloneEnd.style.setProperty('padding', '0 4px', 'important');
        cloneEnd.style.setProperty('box-sizing', 'border-box', 'important');
        track.appendChild(cloneEnd);
      }

      // Track genişliğini güncelle
      var totalSlides = realSlidesForCart.length + (cloneCount * 2);
      var newTrackWidth = slideWidth * totalSlides;
      track.style.setProperty('width', newTrackWidth + 'px', 'important');
      track.style.setProperty('max-width', newTrackWidth + 'px', 'important');
      track.style.setProperty('min-width', newTrackWidth + 'px', 'important');

      // Başlangıç pozisyonunu klonların sonrasına ayarla
      var startPosition = slideWidth * cloneCount;
      slickList.style.setProperty('scroll-behavior', 'auto', 'important');
      slickList.scrollLeft = startPosition;
      requestAnimationFrame(function() {
        slickList.style.setProperty('scroll-behavior', 'smooth', 'important');
      });

      // Scroll event ile infinite loop kontrolü
      var isJumping = false;
      var realContentStart = slideWidth * cloneCount;
      var realContentEnd = realContentStart + (slideWidth * realSlidesForCart.length);

      var handleCartInfiniteScroll = function() {
        if (isJumping) return;

        var scrollLeft = slickList.scrollLeft;

        if (scrollLeft >= realContentEnd - (slideWidth * 2)) {
          isJumping = true;
          var offset = scrollLeft - realContentEnd + slideWidth;
          slickList.style.setProperty('scroll-behavior', 'auto', 'important');
          slickList.style.setProperty('scroll-snap-type', 'none', 'important');
          slickList.scrollLeft = realContentStart + offset;
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              slickList.style.setProperty('scroll-behavior', 'smooth', 'important');
              slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
              isJumping = false;
            });
          });
        }
        else if (scrollLeft <= slideWidth) {
          isJumping = true;
          var offset = realContentStart - scrollLeft;
          slickList.style.setProperty('scroll-behavior', 'auto', 'important');
          slickList.style.setProperty('scroll-snap-type', 'none', 'important');
          slickList.scrollLeft = realContentEnd - slideWidth - offset;
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              slickList.style.setProperty('scroll-behavior', 'smooth', 'important');
              slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
              isJumping = false;
            });
          });
        }
      };

      // Slick'in tüm touch event'lerini engelle - slick-list'i klonla
      var slickListClone = slickList.cloneNode(false);
      while (slickList.firstChild) {
        slickListClone.appendChild(slickList.firstChild);
      }
      slickList.parentNode.replaceChild(slickListClone, slickList);
      slickList = slickListClone;

      // slickList referansını güncelle
      slickList.style.setProperty('overflow-x', 'auto', 'important');
      slickList.style.setProperty('overflow-y', 'clip', 'important');
      slickList.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      slickList.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
      slickList.style.setProperty('touch-action', 'pan-x pan-y', 'important');
      slickList.style.setProperty('overscroll-behavior-x', 'contain', 'important');
      slickList.style.setProperty('scrollbar-width', 'none', 'important');

      // Başlangıç pozisyonunu ayarla
      slickList.scrollLeft = startPosition;

      // Touch event'leri için native scroll
      var touchStartX = 0;
      var touchStartY = 0;
      var isTouchScrolling = false;

      slickList.addEventListener('touchstart', function(e) {
        if (e.touches && e.touches.length > 0) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          isTouchScrolling = false;
        }
      }, { passive: true, capture: true });

      slickList.addEventListener('touchmove', function(e) {
        if (e.touches && e.touches.length > 0) {
          var deltaX = Math.abs(e.touches[0].clientX - touchStartX);
          var deltaY = Math.abs(e.touches[0].clientY - touchStartY);
          if (deltaX > deltaY && deltaX > 10) {
            isTouchScrolling = true;
          }
        }
      }, { passive: true, capture: true });

      var cartScrollTimer = null;
      var lastScrollLeft = slickList.scrollLeft;

      slickList.addEventListener('scroll', function() {
        lastScrollLeft = slickList.scrollLeft;
        clearTimeout(cartScrollTimer);
        cartScrollTimer = setTimeout(handleCartInfiniteScroll, 100);
      }, { passive: true });

      slickList.addEventListener('touchend', function() {
        if (isTouchScrolling) {
          clearTimeout(cartScrollTimer);
          // Touch bittikten sonra scroll durmasını bekle
          var checkScrollEnd = function() {
            var currentScroll = slickList.scrollLeft;
            if (Math.abs(currentScroll - lastScrollLeft) < 1) {
              // Scroll durdu
              handleCartInfiniteScroll();
            } else {
              lastScrollLeft = currentScroll;
              setTimeout(checkScrollEnd, 50);
            }
          };
          setTimeout(checkScrollEnd, 100);
        }
        isTouchScrolling = false;
      }, { passive: true });

      // Ok butonları için 2 kart kaydırma
      var scrollAmount = slideWidth * 2;
      var isScrolling = false;
      var scrollDebounceTime = 350;

      rec.querySelectorAll('.boost-sd__slider-button').forEach(function(btn) {
        var clone = btn.cloneNode(true);
        btn.parentNode.replaceChild(clone, btn);

        var isPrev = false;
        if (clone.classList.contains('boost-sd__slider-button--prev')) isPrev = true;
        if (clone.querySelector('.boost-sd__icon--arrow-left')) isPrev = true;
        if (clone.querySelector('[class*="left"]')) isPrev = true;
        if (clone.querySelector('[class*="prev"]')) isPrev = true;
        var ariaLabel = (clone.getAttribute('aria-label') || '').toLowerCase();
        if (ariaLabel.includes('prev') || ariaLabel.includes('önceki') || ariaLabel.includes('geri')) isPrev = true;

        var isNext = false;
        if (clone.classList.contains('boost-sd__slider-button--next')) isNext = true;
        if (clone.querySelector('.boost-sd__icon--arrow-right')) isNext = true;
        if (clone.querySelector('[class*="right"]')) isNext = true;
        if (clone.querySelector('[class*="next"]')) isNext = true;
        if (ariaLabel.includes('next') || ariaLabel.includes('sonraki') || ariaLabel.includes('ileri')) isNext = true;

        if (!isPrev && !isNext) {
          var allBtns = rec.querySelectorAll('.boost-sd__slider-button');
          var idx = Array.prototype.indexOf.call(allBtns, clone);
          isPrev = idx === 0;
          isNext = idx > 0;
        }

        clone.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          if (isScrolling) return;
          isScrolling = true;

          var direction = isPrev ? -scrollAmount : scrollAmount;
          slickList.scrollBy({
            left: direction,
            behavior: 'smooth'
          });

          setTimeout(function() {
            isScrolling = false;
          }, scrollDebounceTime);
        });
      });
    });
  }

  function hideEmptyCartSections() {
    if (window.innerWidth <= MOBILE_BP) return;
    var sections = document.querySelectorAll('.cart-page-content > .shopify-section');
    sections.forEach(function(section) {
      if (!section.previousElementSibling) return;
      if (section.querySelector('.boost-sd__product-item')) return;
      if (section.querySelector('.cart__footer, #main-cart-footer')) return;
      if (section.querySelector('h1, h2, h3, form, table, article, img')) return;

      var style = window.getComputedStyle(section);
      var padV = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      var contentH = section.getBoundingClientRect().height - padV;
      if (contentH < 10) {
        section.style.display = 'none';
      }
    });
  }

  function fixCheckIcons() {
    document.querySelectorAll('svg.boost-icon-check path').forEach(function(path) {
      path.setAttribute('fill', '#fff');
    });
  }

  /* Viewport değiştiğinde inline font-size stillerini temizle - CSS media query'lerin çalışmasını sağlar */
  function clearInlineFontStyles() {
    var isMobile = window.innerWidth <= MOBILE_BP;

    /* Fiyat elementlerinin style attribute'unu tamamen sil */
    var priceSelectors = [
      '.boost-sd__recommendation .boost-sd__format-currency',
      '.boost-sd__recommendation .boost-sd__product-price--default',
      '.boost-sd__recommendation .boost-sd__product-price--compare',
      '.boost-sd__recommendation .boost-sd__product-price-content',
      '.boost-sd__recommendation .boost-sd__product-price-content span'
    ];

    priceSelectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        /* style attribute'unu tamamen kaldır - !important dahil her şeyi siler */
        el.removeAttribute('style');
      });
    });

    /* s ve del elementleri için sadece renk kalsın, font-size kalksın */
    document.querySelectorAll('.boost-sd__recommendation s, .boost-sd__recommendation del').forEach(function(el) {
      el.removeAttribute('style');
      /* Renkleri geri ekle */
      el.style.setProperty('color', '#000', 'important');
      el.style.setProperty('text-decoration', 'line-through', 'important');
      el.style.setProperty('text-decoration-color', '#c50d00', 'important');
    });

    /* s ve del içindeki span'lar */
    document.querySelectorAll('.boost-sd__recommendation s span, .boost-sd__recommendation del span').forEach(function(el) {
      el.removeAttribute('style');
      el.style.setProperty('color', '#000', 'important');
    });
  }

  /* Surekli fiyat duzeltme - Boost SD'nin uzerine yazmalarini engeller */
  /* Kompakt cart section kontrolu */
  var COMPACT_SECTIONS = ['cartpage-887768', 'cartpage-686707', '17553421409bfab624'];

  function isInCompactSection(el) {
    if (window.innerWidth > 749) return false;
    var rec = el.closest('.boost-sd__recommendation');
    if (!rec) return false;
    var section = rec.closest('.shopify-section') || rec;
    var id = (section.id || '') + '|' + (rec.id || '');
    for (var i = 0; i < COMPACT_SECTIONS.length; i++) {
      if (id.indexOf(COMPACT_SECTIONS[i]) !== -1) return true;
    }
    return false;
  }

 function fixComparePrices() {
    /* Sadece RENK düzeltmeleri - font boyutlarını CSS yönetiyor */

    /* Strikethrough elementleri siyah yap */
    document.querySelectorAll('.boost-sd__recommendation s, .boost-sd__recommendation del').forEach(function(el) {
      el.style.setProperty('color', '#000', 'important');
      el.style.setProperty('text-decoration', 'line-through', 'important');
      el.style.setProperty('text-decoration-color', '#c50d00', 'important');
      el.style.setProperty('text-decoration-thickness', '1.5px', 'important');
      el.style.setProperty('text-decoration-skip-ink', 'none', 'important');
      el.querySelectorAll('*').forEach(function(child) {
        child.style.setProperty('color', '#000', 'important');
        child.style.setProperty('text-decoration', 'none', 'important');
      });
    });

    /* İndirimli ürünlerde default fiyatı yeşil yap */
    document.querySelectorAll('.boost-sd__recommendation .boost-sd__product-price').forEach(function(priceWrapper) {
      var hasCompare = priceWrapper.querySelector('.boost-sd__product-price--compare, s, del');
      if (!hasCompare) return;

      var defaultPrice = priceWrapper.querySelector('.boost-sd__product-price--default');
      if (defaultPrice && defaultPrice.closest('s')) defaultPrice = null;
      if (defaultPrice && defaultPrice.closest('del')) defaultPrice = null;

      if (!defaultPrice) {
        var allCurrencies = priceWrapper.querySelectorAll('.boost-sd__format-currency');
        for (var i = 0; i < allCurrencies.length; i++) {
          var curr = allCurrencies[i];
          /* Eski fiyat değilse (s/del içinde değil, price-compare class'ı yok) */
          var isOldPrice = curr.closest('s') ||
                          curr.closest('del') ||
                          curr.classList.contains('boost-sd__format-currency--price-compare') ||
                          curr.closest('.boost-sd__product-price--compare');
          if (!isOldPrice) {
            defaultPrice = curr;
            break;
          }
        }
      }

      /* Sadece yeni fiyata yeşil uygula, eski fiyat elementlerini atla */
      if (defaultPrice &&
          !defaultPrice.closest('s') &&
          !defaultPrice.closest('del') &&
          !defaultPrice.closest('.boost-sd__product-price--compare') &&
          !defaultPrice.classList.contains('boost-sd__format-currency--price-compare')) {
        defaultPrice.style.setProperty('color', '#44b183', 'important');
      }
    });
  }

  function continuousPriceFix() {
    /* Fiyat stillerini surekli duzelt */
    forceBlackOnStrikethrough();
  }

  function fixAll() {
    moveButtons();
    fixSliders();
    equalizeCardHeights();
    hideEmptyCartSections();
    fixComparePrices();
    fixCheckIcons();
    continuousPriceFix();
  }

  function forceBlackOnStrikethrough() {
    document.querySelectorAll('.boost-sd__recommendation s, .boost-sd__recommendation del').forEach(function(el) {
      el.style.setProperty('color', '#000', 'important');
      el.style.setProperty('text-decoration', 'line-through', 'important');
      el.style.setProperty('text-decoration-color', '#c50d00', 'important');
      el.style.setProperty('text-decoration-thickness', '1.5px', 'important');
      el.style.setProperty('text-decoration-skip-ink', 'none', 'important');
      var children = el.getElementsByTagName('*');
      for (var i = 0; i < children.length; i++) {
        children[i].style.setProperty('color', '#000', 'important');
        children[i].style.setProperty('text-decoration', 'none', 'important');
      }
    });
  }

  function init() {
    injectOverrideCSS();

    var fixTimer = null;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.classList && node.classList.contains('boost-sd__recommendation')) ||
            (node.querySelector && node.querySelector('.boost-sd__recommendation'))
          ) {
            clearInlineFontStyles();
            attachPriceStyleObservers();
            clearTimeout(fixTimer);
            fixTimer = setTimeout(fixAll, 800);
            setTimeout(fixAll, 2000);
            setTimeout(clearInlineFontStyles, 50);
            setTimeout(clearInlineFontStyles, 200);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    var styleObserver = new MutationObserver(function(mutations) {
      var needsFix = false;
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target.closest && (target.closest('s') || target.closest('del'))) {
          if (target.closest('.boost-sd__recommendation')) {
            needsFix = true;
            break;
          }
        }
      }
      if (needsFix) {
        forceBlackOnStrikethrough();
      }
    });

    styleObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      subtree: true
    });

    /* Fiyat elementleri icin ozel observer - her degisiklikte hemen duzelir */
    var priceObserver = new MutationObserver(function(mutations) {
      var needsFix = false;
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target.closest && target.closest('.boost-sd__recommendation')) {
          if (target.classList && (
            target.classList.contains('boost-sd__format-currency') ||
            target.classList.contains('boost-sd__product-price-content') ||
            target.classList.contains('boost-sd__product-price--default') ||
            target.tagName === 'S' || target.tagName === 'DEL'
          )) {
            needsFix = true;
            break;
          }
        }
      }
      if (needsFix) {
        continuousPriceFix();
      }
    });

    priceObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    /* Performans optimizasyonu: 3 setTimeout yerine 2 */
    setTimeout(fixAll, 1500);
    setTimeout(fixAll, 4000);

    var pollCount = 0;
    var pollInterval = setInterval(function () {
      fixAll();
      forceBlackOnStrikethrough();
      pollCount++;
      if (pollCount >= 3) clearInterval(pollInterval);
    }, 2000);

    

    /* Fiyat elementlerinin style degisikliklerini izle ve aninda duzelt */
    var priceStyleObserver = new MutationObserver(function(mutations) {
      var needsColorFix = false;
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'style') {
          var el = mutation.target;
          if (!el.closest || !el.closest('.boost-sd__recommendation')) return;

          /* Font-size inline stil varsa kaldır - CSS media query'lerin çalışması için */
          if (el.style.fontSize) {
            el.style.removeProperty('font-size');
            el.style.removeProperty('line-height');
          }

          /* Renk düzeltmesi */
          if (el.closest('s, del')) {
            if (el.style.color !== 'rgb(0, 0, 0)') {
              needsColorFix = true;
            }
          }
        }
      });
      if (needsColorFix) {
        forceBlackOnStrikethrough();
      }
    });

    /* Tum recommendation alanlarina observer ekle */
    function attachPriceStyleObservers() {
      document.querySelectorAll('.boost-sd__recommendation').forEach(function(rec) {
        if (!rec.dataset.priceStyleObserverAttached) {
          rec.dataset.priceStyleObserverAttached = 'true';
          rec.querySelectorAll('[style]').forEach(function(el) {
            if (el.style.fontSize && el.closest('.boost-sd__product-price-wrapper, .boost-sd__product-price-content, .boost-sd__product-price')) {
              el.style.removeProperty('font-size');
              el.style.removeProperty('line-height');
            }
          });
          priceStyleObserver.observe(rec, {
            attributes: true,
            attributeFilter: ['style'],
            subtree: true
          });
        }
      });
    }

    attachPriceStyleObservers();
    // Performans optimizasyonu: Sürekli çalışan interval yerine sınırlı sayıda kontrol
    // MutationObserver zaten yeni recommendation alanlarında attachPriceStyleObservers çağırıyor (satır 1768)
    var priceObserverPollCount = 0;
    var priceObserverInterval = setInterval(function() {
      attachPriceStyleObservers();
      priceObserverPollCount++;
      if (priceObserverPollCount >= 5) clearInterval(priceObserverInterval);
    }, 2000);

    /* Görüntüler yüklenince yükseklik eşitleme */
    document.addEventListener('load', function(e) {
      if (e.target.tagName === 'IMG' && e.target.closest('.boost-sd__recommendation')) {
        setTimeout(equalizeCardHeights, 50);
      }
    }, true);

    /* İlk render sonrası ek yükseklik eşitleme - optimize edildi */
    setTimeout(equalizeCardHeights, 500);
    setTimeout(equalizeCardHeights, 1500);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        /* Önce inline font stillerini temizle */
        clearInlineFontStyles();

        fixSliders();
        equalizeCardHeights();

        /* Diğer fonksiyonlar çalıştıktan sonra tekrar temizle */
        clearInlineFontStyles();

        /* Boost SD'nin kendi kod'u gecikmeli stil uygulayabilir - optimize edilmiş temizlik */
        setTimeout(clearInlineFontStyles, 100);
        setTimeout(clearInlineFontStyles, 500);
        setTimeout(clearInlineFontStyles, 1000);
      }, 300);
    });

    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        document.querySelectorAll('.boost-sd__recommendation').forEach(function(rec) {
          delete rec.dataset.boostMobileStylesFixed;
          delete rec.dataset.boostMobileButtonsFixed;
          delete rec.dataset.boostSlickDisabled;
          delete rec.dataset.boostClonesRemoved;
          delete rec.dataset.boostButtonsFixed;
          delete rec.dataset.boostSlidersFixed;
          var slickList = rec.querySelector('.slick-list');
          if (slickList) delete slickList.dataset.boostTouchFixed;
          var slickEl = rec.querySelector('.slick-initialized');
          if (slickEl) delete slickEl.dataset.boostSlidersFixed;
        });
        /* Performans optimizasyonu: 3 setTimeout yerine 2 */
        setTimeout(fixAll, 200);
        setTimeout(fixAll, 800);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ---------------------------------------------------------------
   BOOST SD SIDE CART SUMMARY BOX
   --------------------------------------------------------------- */
(function() {
  'use strict';

  function createSummaryBox() {
    const cartFooter = document.querySelector('.boost-sd__cart-footer');

    if (!cartFooter) return;

    if (document.getElementById('boost-sd-summary-box')) {
      updateSummaryBox();
      return;
    }

    const summaryBox = document.createElement('div');
    summaryBox.id = 'boost-sd-summary-box';
    summaryBox.className = 'boost-sd-summary-box';

    const priceDiv = document.createElement('div');
    priceDiv.className = 'boost-sd-summary-box__price';
    priceDiv.id = 'boost-sd-summary-price';
    const currentPriceSpan = document.createElement('span');
    currentPriceSpan.className = 'boost-sd-summary-box__price-current';
    currentPriceSpan.textContent = '0,00₺';
    priceDiv.appendChild(currentPriceSpan);
    summaryBox.appendChild(priceDiv);

    // Summary box'ı en başa ekle (sadece fiyat bilgisi içerir)
    cartFooter.insertBefore(summaryBox, cartFooter.firstChild);

    // Shipping div'i ayrı olarak en sona ekle (Sepeti Görüntüle butonunun altına)
    const shippingDiv = document.createElement('div');
    shippingDiv.className = 'boost-sd-summary-box__shipping';
    shippingDiv.id = 'boost-sd-shipping';
    shippingDiv.textContent = '3000₺ üzeri ücretsiz kargo';
    cartFooter.appendChild(shippingDiv);

    updateSummaryBox();
  }

  function updateSummaryBox() {
    const summaryPriceElement = document.getElementById('boost-sd-summary-price');
    const shippingElement = document.getElementById('boost-sd-shipping');

    fetch('/cart.js')
      .then(response => response.json())
      .then(function(cart) {
        const cartTotal = cart.total_price || 0;

        // cart.js zaten original_line_price döndürüyor — ek fetch gerekmiyor
        let originalPrice = 0;
        if (cart.items && cart.items.length > 0) {
          originalPrice = cart.items.reduce(function(sum, item) {
            return sum + (item.original_line_price || (item.original_price || item.price) * item.quantity);
          }, 0);
        }

        if (summaryPriceElement) {
          summaryPriceElement.textContent = '';

          // Toplam: etiketi önce
          const totalLabel = document.createElement('span');
          totalLabel.className = 'boost-sd-summary-box__price-label';
          totalLabel.textContent = 'Toplam:';
          summaryPriceElement.appendChild(totalLabel);

          // Eski fiyat (varsa)
          if (originalPrice > cartTotal) {
            const oldPriceSpan = document.createElement('s');
            oldPriceSpan.className = 'boost-sd-summary-box__price-old';
            oldPriceSpan.textContent = (originalPrice / 100).toLocaleString('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) + '₺';
            summaryPriceElement.appendChild(oldPriceSpan);
          }

          // Yeni fiyat
          const currentPriceSpan = document.createElement('span');
          currentPriceSpan.className = 'boost-sd-summary-box__price-current';
          currentPriceSpan.textContent = (cartTotal / 100).toLocaleString('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) + '₺';
          summaryPriceElement.appendChild(currentPriceSpan);
        }

        if (shippingElement) {
          const freeShippingThreshold = 300000;
          const remaining = freeShippingThreshold - cartTotal;

          shippingElement.textContent = '';

          if (cartTotal >= freeShippingThreshold) {
            shippingElement.textContent = '🎉 Ücretsiz kargo kazandınız! 🎉';
          } else if (cartTotal > 0) {
            const formattedAmount = (remaining / 100).toLocaleString('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            shippingElement.textContent = '🚚 Ücretsiz kargoya ';
            const strong = document.createElement('strong');
            strong.textContent = formattedAmount + '₺';
            shippingElement.appendChild(strong);
            shippingElement.appendChild(document.createTextNode(' kaldı 🚚'));
          } else {
            shippingElement.textContent = '3000₺ üzeri ücretsiz kargo';
          }
        }
      })
      .catch(error => {
        console.error('Error updating cart summary box:', error);
      });
  }

  function initCartSummaryBox() {
    const observer = new MutationObserver(function(mutations) {
      for (let mutation of mutations) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('boost-sd__cart')) {
              setTimeout(createSummaryBox, 100);
            } else if (node.querySelector && node.querySelector('.boost-sd__cart')) {
              setTimeout(createSummaryBox, 100);
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(function() {
      if (document.querySelector('.boost-sd__cart')) {
        createSummaryBox();
      }
    }, 300);

    if (window.Shopify && window.Shopify.pubsub) {
      if (typeof PUB_SUB_EVENTS !== 'undefined') {
        Shopify.pubsub.subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
          setTimeout(updateSummaryBox, 300);
        });
      }
    }

    let checkCount = 0;
    const checkInterval = setInterval(function() {
      if (document.querySelector('.boost-sd__cart-footer') && !document.getElementById('boost-sd-summary-box')) {
        createSummaryBox();
      }
      checkCount++;
      if (checkCount >= 10) {
        clearInterval(checkInterval);
      }
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSummaryBox);
  } else {
    initCartSummaryBox();
  }

})();

/* ---------------------------------------------------------------
   BOOST SD TÜR FİLTRE CHIP BAR
   Navigation altı yatay filtre chip bar
   --------------------------------------------------------------- */
(function() {
  'use strict';

  var TUR_FILTER_ID = 'pf_pt_tur';
  var CHIP_BAR_ID = 'boost-tur-chip-bar';

  // "View More" veya "Daha Fazla" butonlarını filtrele
  function isViewMoreElement(element) {
    if (!element) return false;
    var text = (element.textContent || element.innerText || '').toLowerCase().trim();
    return text.includes('view more') ||
           text.includes('daha fazla') ||
           text.includes('göster') ||
           text.includes('more') ||
           element.classList.contains('boost-sd__filter-option-view-more') ||
           element.classList.contains('view-more');
  }

  // Filter option'ı işle ve options array'ine ekle
  function processFilterOption(label, checkbox, options) {
    if (!label) return;

    var text = '';
    var count = '';

    // Text ve count'u ayır
    var labelText = label.textContent || label.innerText || '';

    // Count'u bul (parantez içindeki sayı)
    var countMatch = labelText.match(/\((\d+)\)/);
    if (countMatch) {
      count = countMatch[1];
      text = labelText.replace(/\(\d+\)/, '').trim();
    } else {
      text = labelText.trim();
    }

    // Checkbox value'dan da temizle
    text = text.replace(/^\s*[\u2713\u2714\u2611]\s*/, '').trim(); // Checkmark'ları temizle

    if (text && text.length > 0 && !isViewMoreElement(label)) {
      options.push({
        text: text,
        count: count,
        value: checkbox ? checkbox.value : text,
        checked: checkbox ? checkbox.checked : false,
        element: label.closest('.boost-sd__filter-option-item') || label,
        checkbox: checkbox
      });
    }
  }

  // Chip bar'ı title ile hizala (8 veya daha az chip için)
  function alignChipBarWithTitle() {
    var chipBar = document.getElementById(CHIP_BAR_ID);
    if (!chipBar || !chipBar.classList.contains('boost-tur-chip-bar--centered')) {
      return;
    }

    if (window.innerWidth < 750) {
      chipBar.style.removeProperty('padding-left');
      chipBar.style.removeProperty('padding-right');
      return;
    }

    chipBar.style.setProperty('padding-left', '300px', 'important');
    chipBar.style.setProperty('padding-right', '300px', 'important');

  }

  // Resize'da yeniden hizala (debounced)
  var alignDebounceTimer;
  window.addEventListener('resize', function() {
    clearTimeout(alignDebounceTimer);
    alignDebounceTimer = setTimeout(alignChipBarWithTitle, 100);
  });

  function createChipBar() {

    // Sadece collection ve search sayfalarında çalış
    if (!document.body.classList.contains('template-collection') &&
        !document.body.classList.contains('template-search')) {

      return;
    }

    // Zaten oluşturulmuşsa tekrar oluşturma
    if (document.getElementById(CHIP_BAR_ID)) {

      updateChipBar();
      return;
    }

    // Tür filtresi seçeneklerini bul
    var turFilterOptions = findTurFilterOptions();

    // Bazı sayfalarda filtre seçenekleri geç DOM'a düşebiliyor.
    // Seçenek yoksa bile alanı reserve edelim; sonra rebuild ile doldurulur.
    if (!turFilterOptions) turFilterOptions = [];

    // Chip bar container oluştur
    var chipBar = document.createElement('div');
    chipBar.id = CHIP_BAR_ID;
    chipBar.className = 'boost-tur-chip-bar is-loading'; // Loading state ile başla

    // Chip sayısına göre centered class ekle (8 veya daha az ise ortala)
    if (turFilterOptions.length > 0 && turFilterOptions.length <= 8) {
      chipBar.classList.add('boost-tur-chip-bar--centered');
    }

    var container = document.createElement('div');
    container.className = 'boost-tur-chip-bar__container';

    // Her seçenek için chip oluştur
    turFilterOptions.forEach(function(option) {
      var chip = createChip(option);
      container.appendChild(chip);
    });

    // SVG oluşturma yardımcı fonksiyonu
    function createArrowSvg(direction) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('width', '20');
      svg.setAttribute('height', '20');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2');

      var polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      polyline.setAttribute('points', direction === 'left' ? '15,18 9,12 15,6' : '9,18 15,12 9,6');
      svg.appendChild(polyline);

      return svg;
    }

    // Sol ok butonu
    var leftArrow = document.createElement('button');
    leftArrow.className = 'boost-tur-chip-bar__arrow boost-tur-chip-bar__arrow--left';
    leftArrow.setAttribute('type', 'button');
    leftArrow.setAttribute('aria-label', 'Sola kaydır');
    leftArrow.appendChild(createArrowSvg('left'));

    // Sağ ok butonu
    var rightArrow = document.createElement('button');
    rightArrow.className = 'boost-tur-chip-bar__arrow boost-tur-chip-bar__arrow--right';
    rightArrow.setAttribute('type', 'button');
    rightArrow.setAttribute('aria-label', 'Sağa kaydır');
    rightArrow.appendChild(createArrowSvg('right'));

    chipBar.appendChild(leftArrow);
    chipBar.appendChild(container);
    chipBar.appendChild(rightArrow);

    // Ok butonları scroll işlevi
    var scrollAmount = 200;

    leftArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // Ok görünürlüğünü kontrol et
    function updateArrowVisibility() {
      var scrollLeft = container.scrollLeft;
      var maxScroll = container.scrollWidth - container.clientWidth;

      // Sol ok - başta soluk ama tıklanabilir
      leftArrow.style.opacity = scrollLeft > 5 ? '1' : '0.4';

      // Sağ ok - sonda soluk ama tıklanabilir
      rightArrow.style.opacity = scrollLeft < maxScroll - 5 ? '1' : '0.4';
    }

    container.addEventListener('scroll', updateArrowVisibility);
    window.addEventListener('resize', updateArrowVisibility);
    setTimeout(updateArrowVisibility, 100);

    // Yeşil navigation bar'ın (ja-navigations) hemen sonrasına ekle
    var navigation = document.querySelector('.ja-navigations');

    if (navigation && navigation.parentNode) {
      navigation.parentNode.insertBefore(chipBar, navigation.nextSibling);

    } else {
      // Navigation bulunamazsa, ürün grid container'ının önüne ekle
      var productGrid = document.querySelector('.product-grid-container') ||
                        document.querySelector('#ProductGridContainer') ||
                        document.querySelector('.boost-sd__layout');

      if (productGrid && productGrid.parentNode) {
        productGrid.parentNode.insertBefore(chipBar, productGrid);

      } else {
        // Fallback: header'ın sonrasına ekle
        var header = document.querySelector('.ja-header') || document.querySelector('header');
        if (header && header.parentNode) {
          header.parentNode.insertBefore(chipBar, header.nextSibling);

        }
      }
    }

    // Chip bar eklendikten sonra title ile hizala ve ready state'e geç
    requestAnimationFrame(function() {
      alignChipBarWithTitle();
      // Loading'den ready'e geçiş - smooth fade in
      // Seçenek yoksa (skeleton) görünmez kalsın.
      if (turFilterOptions.length > 0) {
        chipBar.classList.remove('is-loading');
        chipBar.classList.add('is-ready');
      }
    });
  }

  function findTurFilterOptions() {
    var options = [];

    // Doğrudan ul#pf_pt_tur içindeki li elementlerini bul
    var filterItems = document.querySelectorAll('ul#' + TUR_FILTER_ID + ' > li.boost-sd__filter-option-item');
    // console.log('[ChipBar Debug] ul#pf_pt_tur li.boost-sd__filter-option-item:', filterItems.length);

    // Alternatif: tüm container'larda ara
    if (filterItems.length === 0) {
      filterItems = document.querySelectorAll('ul#' + TUR_FILTER_ID + ' > li');
      // console.log('[ChipBar Debug] ul#pf_pt_tur li:', filterItems.length);
    }

    // Hala bulunamadıysa data-filteroptionid ile dene
    if (filterItems.length === 0) {
      var containers = document.querySelectorAll('[data-filteroptionid="' + TUR_FILTER_ID + '"]');
      // console.log('[ChipBar Debug] data-filteroptionid containers:', containers.length);
      containers.forEach(function(container) {
        var items = container.querySelectorAll('.boost-sd__filter-option-item, li');
        // console.log('[ChipBar Debug] container items:', items.length);
        if (items.length > 0) {
          filterItems = items;
        }
      });
    }

    // console.log('[ChipBar Debug] Total filterItems:', filterItems.length);

    filterItems.forEach(function(item, index) {
      // Button elementini bul (role="checkbox")
      var button = item.querySelector('button[role="checkbox"], .boost-sd__filter-option-item-button');

      // Eğer item zaten bir button ise
      if (!button && (item.tagName === 'BUTTON' || item.getAttribute('role') === 'checkbox')) {
        button = item;
      }

      // Alternatif: herhangi bir button veya tıklanabilir element
      if (!button) {
        button = item.querySelector('button, [role="button"], input[type="checkbox"]');
      }

      if (!button) {
        // console.log('[ChipBar Debug] Item', index, 'no button found:', item.outerHTML.substring(0, 200));
        return;
      }

      // Label ve count span'larını bul
      var labelSpan = item.querySelector('.boost-sd__filter-option-item-label');
      var countSpan = item.querySelector('.boost-sd__filter-option-item-amount');

      // Alternatif label seçiciler
      if (!labelSpan) {
        labelSpan = item.querySelector('[class*="label"]') ||
                    item.querySelector('span:not([class*="count"]):not([class*="amount"])') ||
                    button;
      }

      if (!labelSpan) {
        return;
      }

      var text = (labelSpan.textContent || labelSpan.innerText || '').trim();

      // Count'u label text'inden çıkar (eğer parantez içindeyse)
      var countMatch = text.match(/\((\d+)\)\s*$/);
      if (countMatch) {
        text = text.replace(/\s*\(\d+\)\s*$/, '').trim();
      }

      var count = '';
      if (countSpan) {
        count = (countSpan.textContent || countSpan.innerText || '').replace(/[()]/g, '').trim();
      } else if (countMatch) {
        count = countMatch[1];
      }

      var isChecked = button.getAttribute('aria-checked') === 'true' ||
                      button.classList.contains('boost-sd__filter-option-item-button--selected') ||
                      button.classList.contains('is-active') ||
                      button.classList.contains('selected');

      // View More butonlarını atla
      if (isViewMoreElement(item) || isViewMoreElement(button) || !text) {
        return;
      }

      // Duplicate kontrolü
      var isDuplicate = options.some(function(opt) {
        return opt.text === text;
      });

      if (!isDuplicate) {
        options.push({
          text: text,
          count: count,
          value: text,
          checked: isChecked,
          element: item,
          button: button
        });
      }
    });

    // console.log('[ChipBar Debug] Found options:', options.length, options.map(function(o) { return o.text; }));
    return options;
  }

  function createChip(option) {
    var chip = document.createElement('button');
    chip.className = 'boost-tur-chip';
    chip.setAttribute('type', 'button');
    chip.setAttribute('data-value', option.value);

    if (option.checked) {
      chip.classList.add('boost-tur-chip--active', 'is-active');
    }

    // Chip içeriği
    var textSpan = document.createElement('span');
    textSpan.className = 'boost-tur-chip__text';
    textSpan.textContent = option.text;
    chip.appendChild(textSpan);

    if (option.count) {
      var countSpan = document.createElement('span');
      countSpan.className = 'boost-tur-chip__count';
      countSpan.textContent = '(' + option.count + ')';
      chip.appendChild(countSpan);
    }

    // Tıklama olayı
    chip.addEventListener('click', function(e) {
      e.preventDefault();
      handleChipClick(option, chip);
    });

    return chip;
  }

  // Label text'inden "(count)" eklerini temizle - findTurFilterOptions ile uyumlu olsun
  function normalizeFilterLabel(text) {
    if (!text) return '';
    return String(text).replace(/\s*\(\d+\)\s*$/, '').trim();
  }

  function handleChipClick(option, chipElement) {
    // ÖNCE mevcut durumu kontrol et (button.click()'ten önce)
    var isCurrentlyActive = chipElement.classList.contains('is-active') || chipElement.classList.contains('boost-tur-chip--active');

    // Karşılaştırma için chip'in temizlenmiş değerini al
    var targetText = normalizeFilterLabel(
      chipElement.getAttribute('data-value') || option.value || option.text
    );

    function findTargetButton() {
      var filterItems = document.querySelectorAll('[data-filteroptionid="' + TUR_FILTER_ID + '"] .boost-sd__filter-option-item');
      var result = { button: null, item: null };
      filterItems.forEach(function(item) {
        if (result.button) return;
        var labelSpan = item.querySelector('.boost-sd__filter-option-item-label');
        if (!labelSpan) return;
        // Boost SD bazen label içine "(count)" ekliyor (özellikle bir filtre
        // uygulandıktan sonra). Normalize ederek karşılaştır.
        var text = normalizeFilterLabel(labelSpan.textContent || labelSpan.innerText || '');
        if (text === targetText) {
          result.button = item.querySelector('button[role="checkbox"], .boost-sd__filter-option-item-button');
          result.item = item;
        }
      });
      return result;
    }

    function fireClick() {
      // Her tıklamada güncel button'u bul. Boost SD filtre uygulandıktan sonra
      // DOM'u yeniden render ediyor, eski option.button referansları detached node
      // oluyor ve .click() sessizce hiçbir şey yapmıyor.
      var target = findTargetButton();

      if (target.button) {
        target.button.click();
        option.button = target.button;
        option.element = target.item;
        return true;
      }
      if (option.button && document.body.contains(option.button)) {
        option.button.click();
        return true;
      }
      if (option.element && document.body.contains(option.element)) {
        var clickable = option.element.querySelector('button, input, a');
        if (clickable) {
          clickable.click();
          return true;
        }
      }
      return false;
    }

    function applyChipStateAndUpdate() {
      // Class'ları hemen güncelle (toggle davranışı)
      if (isCurrentlyActive) {
        chipElement.classList.remove('boost-tur-chip--active', 'is-active');
      } else {
        chipElement.classList.add('boost-tur-chip--active', 'is-active');
      }
      // Mobilde tap sonrası focus'u hemen kaldır
      chipElement.blur();
      // Kısa bir gecikme ile chip bar'ı güncelle (filtre sonuçları yüklendikten sonra)
      setTimeout(updateChipBar, 500);
    }

    if (fireClick()) {
      applyChipStateAndUpdate();
      return;
    }

    // Bulunamadı: filtre paneli kapalı veya "view more" arkasına toplanmış
    // olabilir (özellikle uzun türlerin sonundaki düşük adetli kayıtlar).
    // Önce filtreyi aç, sonra tüm seçenekleri zorla yükleyip retry et.
    expandTurFilter();
    allOptionsLoaded = false;
    loadAllFilterOptions(function() {
      // Bir tick bekle ki Boost SD DOM'u tam render etsin
      requestAnimationFrame(function() {
        if (fireClick()) {
          applyChipStateAndUpdate();
          return;
        }
        // Son çare: URL'i doğrudan manipüle ederek filtreyi uygula/kaldır
        toggleTurFilterByUrl(targetText, isCurrentlyActive);
      });
    });
  }

  // URL'deki pf_pt_tur parametresini manipüle ederek filtreyi toggle et.
  // DOM butonu bulunamadığında son çare olarak kullanılır.
  function toggleTurFilterByUrl(value, isCurrentlyActive) {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    var current = params.get(TUR_FILTER_ID);
    var values = current ? current.split(',').map(function(v) { return v.trim(); }).filter(Boolean) : [];
    var normalizedValue = String(value).trim();

    if (isCurrentlyActive) {
      values = values.filter(function(v) { return v !== normalizedValue; });
    } else if (values.indexOf(normalizedValue) === -1) {
      values.push(normalizedValue);
    }

    if (values.length) {
      params.set(TUR_FILTER_ID, values.join(','));
    } else {
      params.delete(TUR_FILTER_ID);
    }
    params.delete('page');

    var newUrl = url.pathname + (params.toString() ? '?' + params.toString() : '') + url.hash;
    window.location.href = newUrl;
  }

  function updateChipBar() {
    var chipBar = document.getElementById(CHIP_BAR_ID);
    if (!chipBar) return;

    var turFilterOptions = findTurFilterOptions();
    var container = chipBar.querySelector('.boost-tur-chip-bar__container');

    if (!container) return;

    // Mevcut chip'lerin sayısı ile filter seçenek sayısını karşılaştır
    var currentChips = container.querySelectorAll('.boost-tur-chip');

    // Yeni seçenekler geldiyse chip bar'ı yeniden DOM'a yerleştirmek yerine
    // sadece içerideki chip'leri güncelleyelim (layout shift'i azaltır).
    if (turFilterOptions.length > currentChips.length) {
      container.innerHTML = '';
      turFilterOptions.forEach(function(option) {
        container.appendChild(createChip(option));
      });

      // İlk yüklemede ≤8 seçenekle centered ekleniyor ama sonra daha fazla
      // seçenek yüklenince centered kaldırılmalı, aksi halde 300px padding kalır
      if (turFilterOptions.length > 8 && chipBar.classList.contains('boost-tur-chip-bar--centered')) {
        chipBar.classList.remove('boost-tur-chip-bar--centered');
        chipBar.style.removeProperty('padding-left');
        chipBar.style.removeProperty('padding-right');
      }

      container.scrollLeft = 0;

      // Chip'ler geldi; skeleton ise görünür yapalım.
      chipBar.classList.remove('is-loading');
      chipBar.classList.add('is-ready');
      return;
    }

    // Mevcut chip'lerin aktif durumunu güncelle
    currentChips.forEach(function(chip) {
      var chipValue = chip.getAttribute('data-value');
      var matchingOption = turFilterOptions.find(function(opt) {
        return opt.value === chipValue || opt.text === chipValue;
      });

      if (matchingOption) {
        if (matchingOption.checked) {
          chip.classList.add('boost-tur-chip--active', 'is-active');
        } else {
          chip.classList.remove('boost-tur-chip--active', 'is-active');
        }

        // Count'u güncelle
        var countEl = chip.querySelector('.boost-tur-chip__count');
        if (countEl && matchingOption.count) {
          countEl.textContent = '(' + matchingOption.count + ')';
        }
      }
    });

    // Her güncellemede title ile hizala
    alignChipBarWithTitle();
  }

  // Chip bar'ı tamamen yeniden oluştur (yeni seçenekler eklendiğinde)
  var rebuildDebounceTimer = null;
  var isRebuilding = false;

  function rebuildChipBar() {
    // Debounce - çoklu çağrıları engelle
    if (rebuildDebounceTimer) {
      clearTimeout(rebuildDebounceTimer);
    }

    rebuildDebounceTimer = setTimeout(function() {
      if (isRebuilding) return;
      isRebuilding = true;

      // allOptionsLoaded flag'ini sıfırla - tüm seçenekler yeniden yüklenecek
      allOptionsLoaded = false;

      var existingChipBar = document.getElementById(CHIP_BAR_ID);

      // Smooth transition: önce fade out (CSS class ile)
      if (existingChipBar) {
        existingChipBar.classList.remove('is-ready');
        existingChipBar.classList.add('is-loading');

        setTimeout(function() {
          existingChipBar.remove();

          // View More flag'lerini sıfırla
          var turFilter = document.querySelector('[data-filteroptionid="' + TUR_FILTER_ID + '"]');
          if (turFilter) {
            var allElements = turFilter.querySelectorAll('[class*="view-more"], button, a, span');
            allElements.forEach(function(el) {
              if (el._viewMoreClicked) {
                delete el._viewMoreClicked;
              }
            });
          }

          // Tüm seçenekleri yükle, sonra chip bar oluştur
          loadAllFilterOptions(function() {
            createChipBar();
            // createChipBar içinde is-loading -> is-ready geçişi zaten yapılıyor
            isRebuilding = false;
          });
        }, 50);
      } else {
        // View More flag'lerini sıfırla
        var turFilter = document.querySelector('[data-filteroptionid="' + TUR_FILTER_ID + '"]');
        if (turFilter) {
          var allElements = turFilter.querySelectorAll('[class*="view-more"], button, a, span');
          allElements.forEach(function(el) {
            if (el._viewMoreClicked) {
              delete el._viewMoreClicked;
            }
          });
        }

        // Tüm seçenekleri yükle, sonra chip bar oluştur
        loadAllFilterOptions(function() {
          createChipBar();
          isRebuilding = false;
        });
      }
    }, 100);
  }

  // Tür filtresini programatik olarak aç (lazy load için)
  function expandTurFilter() {
    var filterToggle = document.querySelector('#' + TUR_FILTER_ID + '-toggle-target-label') ||
                       document.querySelector('[data-filteroptionid="' + TUR_FILTER_ID + '"] .boost-sd__filter-option-label');

    if (filterToggle) {
      var button = filterToggle.querySelector('button') || filterToggle;
      var isExpanded = button.getAttribute('aria-expanded') === 'true';

      if (!isExpanded && button.click) {
        var savedScrollY = window.scrollY;
        button.click();
        requestAnimationFrame(function() { window.scrollTo(0, savedScrollY); });
        return true;
      }
    }
    return false;
  }

  // "View More" butonuna tıklayarak tüm seçenekleri yükle
  function clickViewMoreInTurFilter() {
    var turFilter = document.querySelector('[data-filteroptionid="' + TUR_FILTER_ID + '"]');
    if (!turFilter) return false;

    var viewMoreBtn = turFilter.querySelector('.boost-sd__filter-option-viewmorebtn');

    if (viewMoreBtn) {
      // Display none olsa bile tıkla
      viewMoreBtn.style.setProperty('display', 'block', 'important');
      viewMoreBtn.click();
      // console.log('[ChipBar Debug] Clicked View More button');
      return true;
    }
    return false;
  }

  // Tüm seçenekleri yüklenene kadar View More'a tıkla (sadece bir kez çalışır)
  var allOptionsLoaded = false;

  // Scroll pozisyonunu koruma - layout shift önleme
  var scrollLockActive = false;
  var lockedScrollY = 0;

  function lockScroll() {
    if (scrollLockActive) return;
    scrollLockActive = true;
    lockedScrollY = window.scrollY;

    // Scroll event'i dinle ve pozisyonu koru
    window.addEventListener('scroll', maintainScrollPosition, { passive: false });
  }

  function unlockScroll() {
    scrollLockActive = false;
    window.removeEventListener('scroll', maintainScrollPosition);
  }

  function maintainScrollPosition() {
    if (scrollLockActive && Math.abs(window.scrollY - lockedScrollY) > 5) {
      window.scrollTo(0, lockedScrollY);
    }
  }

  function loadAllFilterOptions(callback) {
    if (allOptionsLoaded) {
      if (callback) callback();
      return;
    }

    var turFilter = document.querySelector('[data-filteroptionid="' + TUR_FILTER_ID + '"]');
    if (!turFilter) {
      if (callback) callback();
      return;
    }

    // Scroll pozisyonunu kilitle - sayfa zıplamasını önle
    lockScroll();

    // Filtre container'ını geçici olarak görünmez yap (layout shift önleme)
    var filterList = document.querySelector('ul#' + TUR_FILTER_ID);
    var originalStyles = null;
    if (filterList) {
      originalStyles = {
        position: filterList.style.position,
        visibility: filterList.style.visibility,
        height: filterList.style.height,
        overflow: filterList.style.overflow
      };
      var fixedHeight = filterList.getBoundingClientRect().height;
      // Container'ı görünmez ama DOM'da tut (tıklama çalışsın)
      filterList.style.setProperty('visibility', 'hidden', 'important');
      // Layout shift olmasın diye yüksekliği sabitle.
      filterList.style.setProperty('height', fixedHeight + 'px', 'important');
      filterList.style.setProperty('overflow', 'hidden', 'important');
    }

    // View More yüklemesi bazen asenkron olduğu için çok agresif durdurmak
    // chip bar'a eksik seçenekle başlayabiliyor.
    var maxAttempts = 40;
    var attempts = 0;
    var lastCount = 0;
    var stableCount = 0;

    function restoreFilterList() {
      if (filterList && originalStyles) {
        filterList.style.position = originalStyles.position || '';
        filterList.style.visibility = originalStyles.visibility || '';
        filterList.style.height = originalStyles.height || '';
        filterList.style.overflow = originalStyles.overflow || '';
      }
      // Scroll kilidini kaldır
      unlockScroll();
    }

    function tryLoadMore() {
      attempts++;
      // Önce chip'e dönüştürülen elemanları say; yoksa fallback olarak tüm li say.
      var currentCount = document.querySelectorAll('ul#' + TUR_FILTER_ID + ' > li.boost-sd__filter-option-item').length;
      if (currentCount === 0) {
        currentCount = document.querySelectorAll('ul#' + TUR_FILTER_ID + ' > li').length;
      }

      // View More butonunu bul
      var viewMoreBtn = turFilter.querySelector('.boost-sd__filter-option-viewmorebtn');

      // Sayı değişmedi mi kontrol et
      if (currentCount === lastCount) {
        stableCount++;
      } else {
        stableCount = 0;
      }

      // View More butonu yoksa veya uzun süre sabit kaldıysa veya max deneme - dur.
      // (Örn: 80ms içinde liste değişmeyebilir, bu yüzden toleransı artırıyoruz.)
      if ((!viewMoreBtn && stableCount >= 2) || stableCount >= 5 || attempts >= maxAttempts) {
        allOptionsLoaded = true;
        restoreFilterList();
        if (callback) callback();
        return;
      }

      lastCount = currentCount;

      if (viewMoreBtn) {
        // Buton gizli olsa bile görünür yap ve tıkla
        viewMoreBtn.style.setProperty('display', 'block', 'important');
        viewMoreBtn.style.setProperty('visibility', 'visible', 'important');
        viewMoreBtn.click();
        setTimeout(tryLoadMore, 200);
      } else {
        // View More butonu yok - tüm seçenekler zaten yüklenmiş
        allOptionsLoaded = true;
        restoreFilterList();
        if (callback) callback();
      }
    }

    tryLoadMore();
  }

  function initChipBar() {
    // Tüm seçenekleri yükleyip chip bar oluştur (sadece bir kez)
    var chipBarInitialized = false;

    function initChipBarWithAllOptions() {
      if (chipBarInitialized) return false;

      var turFilter = document.querySelector('[data-filteroptionid="' + TUR_FILTER_ID + '"]');
      if (!turFilter) return false;

      chipBarInitialized = true;

      // Önce filtreyi aç
      expandTurFilter();

      // Kısmi seçeneklerle chip bar'ı hemen göster.
      // Tam yükleme bitince yeniden oluşturulacağı için geç yüklemenin
      // neden olduğu layout shift azalır.
      createChipBar();

      // Tüm seçenekleri yükle, sonra chip bar oluştur
      loadAllFilterOptions(function() {
        // Chip bar'ı DOM'dan kaldırmayalım; aksi halde yerleşim tekrar hesaplanıp
        // layout shift'e sebep oluyor. createChipBar() mevcut bar varsa sadece günceller.
        createChipBar();
      });

      return true;
    }

    // Filtre yüklendiğinde başlat - hızlı kontrol
    var checkCount = 0;
    var fastInterval = setInterval(function() {
      checkCount++;

      if (!chipBarInitialized) {
        var turFilter = document.querySelector('[data-filteroptionid="' + TUR_FILTER_ID + '"]');
        if (turFilter) {
          initChipBarWithAllOptions();
          clearInterval(fastInterval);
        }
      }

      if (checkCount > 50) {
        clearInterval(fastInterval);
      }
    }, 50);

    // Yedek kontrol
    setTimeout(function() {
      if (!chipBarInitialized) initChipBarWithAllOptions();
    }, 1500);

    // Filtre seçimi değiştiğinde chip durumlarını güncelle
    var updateDebounceTimer = null;
    document.addEventListener('click', function(e) {
      var filterItem = e.target.closest('.boost-sd__filter-option-item, [class*="filter-option-item"]');
      if (filterItem) {
        // Debounce ile daha hızlı ve akıcı güncelleme
        if (updateDebounceTimer) clearTimeout(updateDebounceTimer);
        updateDebounceTimer = setTimeout(updateChipBar, 150);
      }
    });

    // URL değişikliklerinde chip bar'ı güncelle (AJAX navigasyon)
    var lastUrl = location.href;
    var lastPathname = location.pathname;
    new MutationObserver(function() {
      if (location.href !== lastUrl) {
        var newPathname = location.pathname;
        var isOnlyFilterChange = (newPathname === lastPathname);
        lastUrl = location.href;
        lastPathname = newPathname;

        // Sadece filtre parametresi değiştiyse (aynı sayfa) - chip bar'ı koru, sadece güncelle
        if (isOnlyFilterChange) {
          setTimeout(updateChipBar, 100);
          return;
        }

        // Farklı sayfaya gidildiyse - chip bar'ı yeniden oluştur
        chipBarInitialized = false;
        allOptionsLoaded = false;
        var existingChipBar = document.getElementById(CHIP_BAR_ID);
        if (existingChipBar) {
          existingChipBar.remove();
        }
        initChipBarWithAllOptions();
      }
    }).observe(document, { subtree: true, childList: true });

    // Popstate (geri/ileri butonları)
    window.addEventListener('popstate', function() {
      // Sadece pathname değiştiyse rebuild, değilse update
      var newPathname = location.pathname;
      if (newPathname === lastPathname) {
        updateChipBar();
        lastUrl = location.href;
        return;
      }

      lastPathname = newPathname;
      lastUrl = location.href;
      chipBarInitialized = false;
      allOptionsLoaded = false;
      var existingChipBar = document.getElementById(CHIP_BAR_ID);
      if (existingChipBar) {
        existingChipBar.remove();
      }
      initChipBarWithAllOptions();
    });

    // Boost SD custom event'lerini dinle
    var boostEventDebounce = null;
    ['boost-sd:filter-loaded', 'boost-sd:filter-updated', 'boost:filter:updated', 'boostsd:ready'].forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        // Debounce ile çoklu event'leri birleştir
        if (boostEventDebounce) clearTimeout(boostEventDebounce);
        boostEventDebounce = setTimeout(function() {
          // Önce updateChipBar dene, sadece gerekirse rebuild
          var chipBar = document.getElementById(CHIP_BAR_ID);
          if (chipBar) {
            updateChipBar();
          } else {
            rebuildChipBar();
          }
        }, 50);
      });
    });

    // L3 menü açık/kapalı durumunu izle
    function checkL3MenuState() {
      var l3Active = document.querySelector('.ja-navigation-dropdown-menu.l3-active') ||
                     document.querySelector('.ja-navigation-sub-dropdown.active');
      if (l3Active) {
        document.body.classList.add('l3-menu-open');
      } else {
        document.body.classList.remove('l3-menu-open');
      }
    }

    // L3 durumunu izle - tüm navigation tıklamalarında
    document.addEventListener('click', function(e) {
      if (e.target.closest('.ja-navigations')) {
        setTimeout(checkL3MenuState, 150);
      }
    });

    // Sayfa yüklendiğinde kontrol et
    setTimeout(checkL3MenuState, 500);
    checkL3MenuState();
  }

  // Başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChipBar);
  } else {
    initChipBar();
  }

})();


/* ---------------------------------------------------------------
   ÜRÜN SAYISINI BAŞLIK HIZASINA TAŞI (MOBİL)
   Boost toolbar'daki ürün sayısını yip-insert-title başlığının
   yanına taşır, MutationObserver ile senkron tutar.
   --------------------------------------------------------------- */
(function() {
  'use strict';

  var INLINE_COUNT_CLASS = 'yip-title-product-count';

  function moveProductCountToTitle() {
    if (window.innerWidth >= 750) return false;

    var titleWrapper = document.querySelector('.yip-insert-title-wrapper');
    if (!titleWrapper) return false;
    if (titleWrapper.querySelector('.' + INLINE_COUNT_CLASS)) return true;

    var productCount = document.querySelector('.boost-sd__toolbar-item--product-count');
    if (!productCount || !productCount.textContent.trim()) return false;

    var inlineCount = document.createElement('span');
    inlineCount.className = INLINE_COUNT_CLASS;
    inlineCount.textContent = productCount.textContent.trim();
    titleWrapper.appendChild(inlineCount);

    productCount.style.display = 'none';

    var observer = new MutationObserver(function() {
      var text = productCount.textContent.trim();
      if (text) inlineCount.textContent = text;
    });
    observer.observe(productCount, { childList: true, subtree: true, characterData: true });

    return true;
  }

  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    if (moveProductCountToTitle() || attempts > 40) {
      clearInterval(interval);
    }
  }, 500);
})();

/* ---------------------------------------------------------------
   BOOST CART DRAWER CROSS-SELL
   Sepet drawer'ında ürün önerileri gösterir
   --------------------------------------------------------------- */
(function() {
  'use strict';

  var BoostCartCrossSell = {
    initialized: false,

    init: function() {
      var self = this;

      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              var cartDrawer = (node.classList && node.classList.contains('boost-sd__cart--side'))
                ? node
                : (node.querySelector && node.querySelector('.boost-sd__cart--side'));

              if (cartDrawer) {
                setTimeout(function() {
                  self.injectCrossSell(cartDrawer);
                }, 100);
              }
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });

      var existingCart = document.querySelector('.boost-sd__cart--side');
      if (existingCart) {
        this.injectCrossSell(existingCart);
      }
    },

    injectCrossSell: function(cartDrawer) {
      var self = this;

      if (cartDrawer.querySelector('#BoostCartCrossSell')) return;

      var cartBody = cartDrawer.querySelector('.boost-sd__cart-body');
      if (!cartBody) {
        cartBody = cartDrawer.querySelector('.boost-sd__cart-content') || cartDrawer;
      }

      var container = document.createElement('div');
      container.id = 'BoostCartCrossSell';
      container.style.cssText = 'position:sticky;bottom:0;left:0;right:0;padding:0;background:#fff;border-top:1px solid #e5e5e5;z-index:10;overflow:visible;';
      container.setAttribute('data-widget-id', 'cartpage-527251');

      var wrapper = document.createElement('div');
      wrapper.id = 'cartpage-527251';
      wrapper.style.cssText = 'margin:0;padding:0;';

      var title = document.createElement('h3');
      title.style.cssText = 'font-size:14px;font-weight:600;margin:0;padding:2px 16px;color:#333;';
      title.textContent = 'Bunlarla Birlikte Alındı';
      container.appendChild(title);

      var content = document.createElement('div');
      content.id = 'BoostCartCrossSell-Content';
      content.style.cssText = 'min-height:0;overflow:visible;';

      var loading = document.createElement('div');
      loading.id = 'BoostCartCrossSell-Loading';
      loading.style.cssText = 'display:flex;justify-content:center;padding:16px;';

      var spinner = document.createElement('div');
      spinner.style.cssText = 'width:24px;height:24px;border:2px solid #e5e5e5;border-top-color:#06683F;border-radius:50%;animation:boostcsspin 0.8s linear infinite;';
      loading.appendChild(spinner);
      content.appendChild(loading);
      container.appendChild(content);

      var style = document.createElement('style');
      style.textContent = '@keyframes boostcsspin{to{transform:rotate(360deg)}}';
      container.appendChild(style);
      wrapper.appendChild(container);

      // Footer'ın üstüne ekle (sticky olarak kalacak)
      var cartFooter = cartDrawer.querySelector('.boost-sd__cart-footer');
      if (cartFooter) {
        cartFooter.parentNode.insertBefore(wrapper, cartFooter);
      } else {
        cartBody.appendChild(wrapper);
      }

      this.loadRecommendations();
    },

    // Widget'tan ürün bilgilerini parse et
    parseProductFromWidget: function(item) {
      // Ürün linkini bul
      var linkEl = item.querySelector('a.boost-sd__product-link');
      var url = linkEl ? linkEl.getAttribute('href') : '';

      // Ürün resmini bul
      var imgEl = item.querySelector('.boost-sd__product-image-img');
      var imgSrc = imgEl ? (imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '') : '';

      // Ürün başlığını bul
      var titleEl = item.querySelector('.boost-sd__product-title');
      var title = titleEl ? titleEl.textContent.trim() : '';

      // Fiyatı bul - önce indirimli fiyatı dene, yoksa normal fiyat
      var priceEl = item.querySelector('.boost-sd__product-price--sale .boost-sd__format-currency') ||
                    item.querySelector('.boost-sd__format-currency:not(.boost-sd__format-currency--price-compare)') ||
                    item.querySelector('.boost-sd__product-price--default');
      var priceText = priceEl ? priceEl.textContent.trim() : '0';
      // Fiyatı sayıya çevir (₺, TL ve . karakterlerini temizle, virgülü noktaya çevir)
      var priceNum = parseFloat(priceText.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
      var priceInCents = Math.round(priceNum * 100);

      // Variant ID'yi bul - boost select-option butonundan
      var addToCartBtn = item.querySelector('.boost-sd__button--select-option');
      var variantId = null;

      if (addToCartBtn) {
        // Tüm data attribute'ları kontrol et
        variantId = addToCartBtn.getAttribute('data-variant-id') ||
                    addToCartBtn.getAttribute('data-boost-sd-variant-id') ||
                    addToCartBtn.getAttribute('data-product-variant-id');
      }

      // Product item'dan da deneyelim
      if (!variantId) {
        variantId = item.getAttribute('data-variant-id') ||
                    item.getAttribute('data-product-variant-id') ||
                    item.getAttribute('data-boost-sd-variant-id');
      }

      // Form input'tan da deneyelim
      if (!variantId) {
        var variantInput = item.querySelector('input[name="id"]');
        if (variantInput) variantId = variantInput.value;
      }

      // Slide container'dan deneyelim
      if (!variantId) {
        var slideParent = item.closest('.boost-sd__slide');
        if (slideParent) {
          variantId = slideParent.getAttribute('data-variant-id') ||
                      slideParent.getAttribute('data-product-variant-id');
        }
      }

      return {
        title: title,
        url: url,
        featured_image: imgSrc,
        price: priceInCents,
        variantId: variantId
      };
    },

    // URL'den handle çıkar
    getHandleFromUrl: function(url) {
      var match = url.match(/\/products\/([^\/\?#]+)/);
      return match ? match[1] : null;
    },

    // Ürün JSON'unu fetch et ve variant ID al
    fetchVariantId: function(url) {
      var handle = this.getHandleFromUrl(url);
      if (!handle) return Promise.resolve(null);

      return fetch('/products/' + handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.product && data.product.variants && data.product.variants.length > 0) {
            var variant = data.product.variants[0];
            // Shopify JSON'dan gelen fiyat string ve TL cinsinden (örn: "149.90")
            // Kuruşa çevir (örn: 14990)
            var priceInCents = Math.round(parseFloat(variant.price) * 100);
            return { id: variant.id, price: priceInCents };
          }
          return null;
        })
        .catch(function() { return null; });
    },

    loadRecommendations: function() {
      var self = this;
      var content = document.getElementById('BoostCartCrossSell-Content');
      var loading = document.getElementById('BoostCartCrossSell-Loading');
      var container = document.getElementById('BoostCartCrossSell');

      if (!content) return;

      // Sepetteki ürünleri al ve onlara göre öneriler getir
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (!cart.items || cart.items.length === 0) {
            if (loading) loading.style.display = 'none';
            if (container) container.style.display = 'none';
            return;
          }

          // Sepetteki ürün ID'lerini al
          var cartProductIds = cart.items.map(function(item) { return item.product_id; });
          var cartVariantIds = cart.items.map(function(item) { return item.variant_id; });

          // Her sepet ürünü için recommendations al
          var recommendationPromises = cart.items.slice(0, 3).map(function(item) {
            return fetch('/recommendations/products.json?product_id=' + item.product_id + '&limit=6')
              .then(function(r) { return r.json(); })
              .then(function(data) { return data.products || []; })
              .catch(function() { return []; });
          });

          Promise.all(recommendationPromises).then(function(results) {
            // Tüm önerileri birleştir
            var allRecommendations = [];
            var seenIds = {};

            results.forEach(function(products) {
              products.forEach(function(product) {
                // Sepette olmayan ve daha önce eklenmemiş ürünleri ekle
                if (!cartProductIds.includes(product.id) && !seenIds[product.id]) {
                  seenIds[product.id] = true;
                  allRecommendations.push(product);
                }
              });
            });

            if (allRecommendations.length === 0) {
              if (loading) loading.style.display = 'none';
              if (container) container.style.display = 'none';
              return;
            }

            // Shopify recommendations API zaten variants + compare_at_price döndürüyor.
            // Ek fetch'e gerek yok — doğrudan kullan.
            var finalProducts = allRecommendations.slice(0, 12).map(function(product) {
              var variant = product.variants && product.variants[0];
              var price = variant ? variant.price : product.price;
              // Shopify API fiyatları string "149.90" veya cent olarak döndürebilir
              var priceInCents = price > 1000 ? price : Math.round(parseFloat(price) * 100);
              var compareAt = variant && variant.compare_at_price ? variant.compare_at_price : 0;
              var compareInCents = compareAt > 1000 ? compareAt : (compareAt ? Math.round(parseFloat(compareAt) * 100) : 0);

              return {
                id: product.id,
                title: product.title,
                url: '/products/' + product.handle,
                featured_image: product.featured_image || (product.images && product.images[0]) || '',
                price: priceInCents,
                compare_at_price: compareInCents,
                variants: variant ? [{ id: variant.id, price: priceInCents, compare_at_price: compareInCents }] : []
              };
            });

            if (loading) loading.style.display = 'none';
            self.renderProducts(finalProducts, content);
            self.createHiddenBoostWidget(finalProducts);
          });
        })
        .catch(function() {
          if (loading) loading.style.display = 'none';
          if (container) container.style.display = 'none';
        });
    },

    /* Gizli Boost recommendation widget oluştur (analytics tracking için).
       Boost'un SSR analytics modülü bu markup'ı tanıyıp impression ve
       click tracking kaydeder. Kullanıcıya görünmez. */
    createHiddenBoostWidget: function(products) {
      var HIDDEN_ID = 'boost-hidden-rec-527251';
      var existing = document.getElementById(HIDDEN_ID);
      if (existing) existing.remove();

      if (!products || products.length === 0) return;

      // Görünmez ama DOM'da "mevcut" wrapper — Boost'un observer'ları algılayabilsin
      var wrapper = document.createElement('div');
      wrapper.id = HIDDEN_ID;
      wrapper.setAttribute('aria-hidden', 'true');
      wrapper.style.cssText = 'position:fixed;bottom:0;left:0;width:100%;height:0;overflow:hidden;opacity:0;pointer-events:none;z-index:-1;';

      // Boost'un beklediği recommendation markup yapısı
      var rec = document.createElement('div');
      rec.className = 'boost-sd__recommendation';
      rec.id = 'boost-sd-widget-cartpage-527251';
      rec.setAttribute('data-widget-id', 'cartpage-527251');

      var slider = document.createElement('div');
      slider.className = 'boost-sd__slider';

      var track = document.createElement('div');
      track.className = 'slick-track';

      products.forEach(function(product) {
        var variant = product.variants && product.variants[0];
        var variantId = variant ? String(variant.id) : '';
        var productUrl = product.url || '';

        var slide = document.createElement('div');
        slide.className = 'slick-slide boost-sd__slide';

        var item = document.createElement('div');
        item.className = 'boost-sd__product-item';
        if (product.id) item.setAttribute('data-product-id', product.id);
        if (variantId) item.setAttribute('data-variant-id', variantId);

        var link = document.createElement('a');
        link.className = 'boost-sd__product-link boost-sd__product-image';
        link.href = productUrl;

        var title = document.createElement('div');
        title.className = 'boost-sd__product-title';
        title.textContent = product.title || '';

        var btn = document.createElement('button');
        btn.className = 'boost-sd__button boost-sd__button--select-option';
        btn.setAttribute('type', 'button');
        if (variantId) btn.setAttribute('data-variant-id', variantId);
        btn.setAttribute('data-product-url', productUrl);
        btn.setAttribute('data-boost-hidden-atc', 'true');

        item.appendChild(link);
        item.appendChild(title);
        item.appendChild(btn);
        slide.appendChild(item);
        track.appendChild(slide);
      });

      slider.appendChild(track);
      rec.appendChild(slider);
      wrapper.appendChild(rec);
      document.body.appendChild(wrapper);

      // Boost'un regisCustomization callback'lerini tetikle
      try {
        var wi = window.boostWidgetIntegration;
        if (wi && typeof wi.regisCustomization === 'function') {
          wi.regisCustomization(function() {}, 'recommendation');
        }
      } catch(e) {}
    },

    createArrowSvg: function(direction) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('width', '16');
      svg.setAttribute('height', '16');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2.5');

      var polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      polyline.setAttribute('points', direction === 'left' ? '15,18 9,12 15,6' : '9,18 15,12 9,6');
      svg.appendChild(polyline);

      return svg;
    },

    getCardWidth: function() {
      var containerWidth = document.getElementById('BoostCartCrossSell')?.offsetWidth || 300;
      var gap = 10;
      var visibleCount = 3; // Her zaman 3 ürün göster
      var totalGaps = (visibleCount - 1) * gap;
      var sliderPadding = 60; // 30px sol + 30px sağ (oklara yer)
      var cardWidth = Math.floor((containerWidth - totalGaps - sliderPadding) / visibleCount);
      return Math.max(cardWidth, 90);
    },

    renderProducts: function(products, containerEl) {
      while (containerEl.firstChild) {
        containerEl.removeChild(containerEl.firstChild);
      }

      var self = this;
      var cardWidth = this.getCardWidth();

      // Wrapper (pozisyon relative)
      var wrapper = document.createElement('div');
      wrapper.style.cssText = 'position:relative;overflow:visible;';

      // Sol ok - sol kenarda
      var leftArrow = document.createElement('button');
      leftArrow.type = 'button';
      leftArrow.style.cssText = 'position:absolute;left:4px;top:50%;transform:translateY(-50%);z-index:10;width:28px;height:28px;border:none;border-radius:50%;background:#06683F;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;opacity:0.4;transition:opacity 0.2s;box-shadow:0 2px 4px rgba(0,0,0,0.15);';
      leftArrow.appendChild(this.createArrowSvg('left'));

      // Sağ ok - sağ kenarda
      var rightArrow = document.createElement('button');
      rightArrow.type = 'button';
      rightArrow.style.cssText = 'position:absolute;right:4px;top:50%;transform:translateY(-50%);z-index:10;width:28px;height:28px;border:none;border-radius:50%;background:#06683F;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;opacity:1;transition:opacity 0.2s;box-shadow:0 2px 4px rgba(0,0,0,0.15);';
      rightArrow.appendChild(this.createArrowSvg('right'));

      // Slider
      var slider = document.createElement('div');
      slider.style.cssText = 'display:flex;gap:10px;overflow:auto visible;padding:10px 10px 4px;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;align-items:stretch;';
      slider.className = 'boost-cs-slider';

      // Scrollbar gizle
      var style = document.createElement('style');
      style.textContent = '#BoostCartCrossSell-Content .boost-cs-slider::-webkit-scrollbar{display:none}';
      containerEl.appendChild(style);

      products.forEach(function(product) {
        var variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
        var variantPrice = product.variants && product.variants[0] ? product.variants[0].price : product.price;
        var compareAtPrice = product.variants && product.variants[0] ? product.variants[0].compare_at_price : (product.compare_at_price || 0);
        var isOnSale = compareAtPrice && compareAtPrice > variantPrice;
        var price = (variantPrice / 100).toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '₺';
        var imgSrc = product.featured_image ? product.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_200x200.$1') : '';

        var card = document.createElement('div');
        card.className = 'boost-cs-card';
        card.style.cssText = 'position:relative;flex:0 0 ' + cardWidth + 'px;min-width:' + cardWidth + 'px;background:#fff;overflow:visible;';

        var link = document.createElement('a');
        link.href = product.url;
        link.style.cssText = 'text-decoration:none;display:flex;flex-direction:column;height:100%;';

        var imgWrapper = document.createElement('div');
        imgWrapper.style.cssText = 'position:relative;width:100%;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;background:#fff;border:1px solid #e5e5e5;border-radius:8px;overflow:visible;';

        if (imgSrc) {
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = product.title;
          img.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;';
          imgWrapper.appendChild(img);
        }

        var info = document.createElement('div');
        info.style.cssText = 'padding:4px 0;background:#fff;flex:1;display:flex;flex-direction:column;';

        var titleP = document.createElement('p');
        titleP.style.cssText = 'font-size:10px;line-height:1.3;color:#333;margin:0 0 3px 0;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;flex:1;';
        titleP.textContent = product.title;
        info.appendChild(titleP);

        var priceP = document.createElement('p');
        priceP.style.cssText = 'font-size:11px;font-weight:600;margin:0;display:flex;flex-direction:column;gap:2px;align-items:flex-start;';

        if (isOnSale) {
          // Eski fiyat - üst satır (siyah, üstü çizili)
          var oldPriceSpan = document.createElement('span');
          var comparePrice = (compareAtPrice / 100).toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '₺';
          oldPriceSpan.style.cssText = 'color:#000;text-decoration:line-through;text-decoration-color:#c50d00;';
          oldPriceSpan.textContent = comparePrice;
          priceP.appendChild(oldPriceSpan);

          // Yeni fiyat - alt satır (yeşil)
          var newPriceSpan = document.createElement('span');
          newPriceSpan.style.cssText = 'color:#49b187;';
          newPriceSpan.textContent = price;
          priceP.appendChild(newPriceSpan);
        } else {
          priceP.style.color = '#000';
          priceP.textContent = price;
        }

        info.appendChild(priceP);

        // Sepete ekle butonu - kartın sağ üst köşesinde
        var addBtn = null;
        if (variantId) {
          addBtn = document.createElement('button');
          addBtn.type = 'button';
          addBtn.style.cssText = 'position:absolute;top:-10px;right:-10px;width:32px;height:32px;border:none;border-radius:50%;background:#06683F;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,0.25);transition:transform 0.2s;z-index:15;';
          addBtn.setAttribute('data-variant-id', variantId);
          addBtn.setAttribute('data-product-image', imgSrc);
          addBtn.setAttribute('data-product-title', product.title);
          addBtn.setAttribute('data-product-url', product.url);
          addBtn.setAttribute('data-product-price', variantPrice);

          // + ikonu
          var plusSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          plusSvg.setAttribute('width', '18');
          plusSvg.setAttribute('height', '18');
          plusSvg.setAttribute('viewBox', '0 0 24 24');
          plusSvg.setAttribute('fill', 'none');
          plusSvg.setAttribute('stroke', 'currentColor');
          plusSvg.setAttribute('stroke-width', '3');
          plusSvg.classList.add('boost-cs-plus-icon');
          var line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
          line1.setAttribute('x1', '12');
          line1.setAttribute('y1', '5');
          line1.setAttribute('x2', '12');
          line1.setAttribute('y2', '19');
          var line2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
          line2.setAttribute('x1', '5');
          line2.setAttribute('y1', '12');
          line2.setAttribute('x2', '19');
          line2.setAttribute('y2', '12');
          plusSvg.appendChild(line1);
          plusSvg.appendChild(line2);
          addBtn.appendChild(plusSvg);

          // Tik ikonu (başlangıçta gizli)
          var checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          checkSvg.setAttribute('width', '18');
          checkSvg.setAttribute('height', '18');
          checkSvg.setAttribute('viewBox', '0 0 24 24');
          checkSvg.setAttribute('fill', 'none');
          checkSvg.setAttribute('stroke', 'currentColor');
          checkSvg.setAttribute('stroke-width', '3');
          checkSvg.setAttribute('stroke-linecap', 'round');
          checkSvg.setAttribute('stroke-linejoin', 'round');
          checkSvg.classList.add('boost-cs-check-icon');
          checkSvg.style.display = 'none';
          var checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
          checkPath.setAttribute('points', '20 6 9 17 4 12');
          checkSvg.appendChild(checkPath);
          addBtn.appendChild(checkSvg);

          // Hover eventleri
          addBtn.addEventListener('mouseenter', function() {
            if (!this.classList.contains('boost-cs-added')) {
              this.style.background = '#06683F';
              this.style.transform = 'scale(1.08)';
            }
          });
          addBtn.addEventListener('mouseleave', function() {
            if (!this.classList.contains('boost-cs-added')) {
              this.style.background = '#06683F';
              this.style.transform = 'scale(1)';
            }
          });

          addBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // e.stopPropagation() kaldırıldı - Boost analytics tracking için event yukarı çıkmalı
            var vid = this.getAttribute('data-variant-id');
            var btn = this;

            // Butondan ürün bilgilerini al (doğru resim için)
            var storedImage = btn.getAttribute('data-product-image');
            var storedTitle = btn.getAttribute('data-product-title');
            var storedUrl = btn.getAttribute('data-product-url');
            var storedPrice = btn.getAttribute('data-product-price');

            btn.classList.add('boost-cs-added');
            btn.style.transform = 'scale(0.9)';
            btn.style.background = '#06683F';

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            })
            .then(function(r) { return r.json(); })
            .then(function(addedItem) {
              // Tik ikonunu göster, + ikonunu gizle
              var plusIcon = btn.querySelector('.boost-cs-plus-icon');
              var checkIcon = btn.querySelector('.boost-cs-check-icon');
              if (plusIcon) plusIcon.style.display = 'none';
              if (checkIcon) checkIcon.style.display = 'block';
              btn.classList.add('boost-cs-added');
              btn.style.background = '#28a745';

              setTimeout(function() {
                // + ikonunu göster, tik ikonunu gizle
                if (plusIcon) plusIcon.style.display = 'block';
                if (checkIcon) checkIcon.style.display = 'none';
                btn.classList.remove('boost-cs-added');
                btn.style.background = '#06683F';
                btn.style.transform = 'scale(1)';
              }, 1500);

              // Eklenen ürünü drawer'a manuel olarak ekle
              // Butondan aldığımız bilgileri kullan (doğru resim)
              var addedProduct = addedItem;
              addedProduct.image = storedImage || addedItem.image;
              addedProduct.product_title = storedTitle || addedItem.product_title || addedItem.title;
              addedProduct.url = storedUrl || addedItem.url;
              if (storedPrice) addedProduct.price = parseInt(storedPrice);

              fetch('/cart.js')
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                  // PubSub event
                  if (window.Shopify && window.Shopify.pubsub && typeof PUB_SUB_EVENTS !== 'undefined') {
                    Shopify.pubsub.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cross-sell', cartData: cart });
                  }

                  // Summary box güncelle
                  if (typeof updateSummaryBox === 'function') {
                    updateSummaryBox();
                  }

                  // Cart count güncelle
                  document.querySelectorAll('.boost-sd__cart-count, .boost-sd__cart-icon-count, .cart-count-bubble span').forEach(function(el) {
                    el.textContent = cart.item_count;
                  });

                  // Sepetteki eklenen ürünü bul - gerçek fiyatı almak için
                  var cartItem = null;
                  var addedVariantId = addedProduct.variant_id || addedProduct.id;
                  if (cart.items) {
                    for (var i = 0; i < cart.items.length; i++) {
                      if (String(cart.items[i].variant_id) === String(addedVariantId) || String(cart.items[i].id) === String(addedVariantId)) {
                        cartItem = cart.items[i];
                        break;
                      }
                    }
                  }

                  // Eklenen ürünü Boost cart'a ekle - mevcut öğeyi klonlayarak
                  var cartBody = document.querySelector('.boost-sd__cart-body');
                  if (cartBody && addedProduct) {
                    var productId = addedProduct.product_id;
                    var title = addedProduct.product_title || addedProduct.title || '';
                    // Cart'tan gelen gerçek fiyatı kullan (indirimler dahil)
                    var actualPrice = cartItem ? cartItem.price : (storedPrice ? parseInt(storedPrice) : addedProduct.price);
                    var price = (actualPrice / 100).toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    var imgSrc = addedProduct.image || '';
                    var productUrl = addedProduct.url || '/products/' + (addedProduct.handle || '');
                    var variantId = addedProduct.variant_id || addedProduct.id;

                    // Animasyon ve layout stilleri
                    if (!document.getElementById('boost-fade-style')) {
                      var animStyle = document.createElement('style');
                      animStyle.id = 'boost-fade-style';
                      animStyle.textContent = '@keyframes boostFadeIn{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}@keyframes boostFadeOut{from{opacity:1;transform:translateX(0)}to{opacity:0;transform:translateX(20px)}}' +
                        '.boost-sd__cart-item .boost-sd__cart-item-quantity{display:flex!important;flex-direction:row!important;align-items:center!important;justify-content:space-between!important;gap:4px!important;width:100%!important;flex-wrap:nowrap!important;}' +
                        '.boost-sd__cart-item .boost-sd__input-number{flex:0 0 auto!important;display:inline-flex!important;max-width:100px!important;}' +
                        '.boost-sd__cart-item .boost-sd__cart-item-quantity-price{white-space:nowrap!important;flex:0 0 auto!important;font-size:12px!important;text-align:right!important;display:inline-flex!important;align-items:center!important;margin-left:auto!important;padding-left:4px!important;}' +
                        '.boost-sd__cart-item .boost-sd__cart-item-price-value{font-size:12px!important;}' +
                        '.boost-sd__cart-item .boost-sd__cart-item-quantity-character{font-size:12px!important;}';
                      document.head.appendChild(animStyle);
                    }

                    // Mevcut bir Boost cart item'ı klonla (yapı birebir aynı olsun)
                    var existingItem = cartBody.querySelector('.boost-sd__cart-item:not(.boost-sd__cart-item--custom)');
                    var newAddedItem;

                    if (existingItem) {
                      newAddedItem = existingItem.cloneNode(true);
                      newAddedItem.classList.add('boost-sd__cart-item--added', 'boost-sd__cart-item--custom');
                      newAddedItem.style.animation = 'boostFadeIn 0.3s ease';
                      if (newAddedItem.dataset) {
                        newAddedItem.dataset.productId = productId;
                        newAddedItem.dataset.variantId = variantId;
                      }
                      newAddedItem.setAttribute('data-product-id', productId);
                      newAddedItem.setAttribute('data-variant-id', variantId);

                      // Resmi güncelle
                      var img = newAddedItem.querySelector('img');
                      if (img && imgSrc) {
                        // srcset'i temizle (eski resim göstermesin)
                        img.removeAttribute('srcset');
                        img.removeAttribute('data-srcset');
                        img.src = imgSrc;
                        img.alt = title;
                        // ID'yi de güncelle
                        if (img.id) {
                          img.id = 'product-image-' + productId;
                        }
                      }

                      // Başlığı güncelle
                      var titleEl = newAddedItem.querySelector('.boost-sd__cart-item-title');
                      if (titleEl) titleEl.textContent = title;

                      // Ürün linklerini güncelle
                      newAddedItem.querySelectorAll('.boost-sd__product-link, a[href]').forEach(function(link) {
                        if (link.getAttribute('href') && link.getAttribute('href') !== '#') {
                          link.setAttribute('href', productUrl);
                        }
                      });

                      // Fiyatı güncelle - tüm olası fiyat elementlerini bul
                      var priceSelectors = [
                        '.boost-sd__cart-item-price-value',
                        '.boost-sd__cart-item-price',
                        '.boost-sd__price-value',
                        '[class*="price-value"]',
                        '[class*="item-price"]'
                      ];
                      var priceEl = null;
                      for (var ps = 0; ps < priceSelectors.length; ps++) {
                        priceEl = newAddedItem.querySelector(priceSelectors[ps]);
                        if (priceEl) break;
                      }
                      if (priceEl) {
                        priceEl.textContent = price + '₺';
                        priceEl.style.setProperty('font-size', '12px', 'important');
                      } else {
                        // Fiyat elementi bulunamadı, quantity-price içine yaz
                        var qtyPrice = newAddedItem.querySelector('.boost-sd__cart-item-quantity-price');
                        if (qtyPrice) {
                          // x karakterini koru, sadece fiyatı güncelle
                          var xChar = qtyPrice.querySelector('.boost-sd__cart-item-quantity-character');
                          qtyPrice.innerHTML = '';
                          if (xChar) qtyPrice.appendChild(xChar.cloneNode(true));
                          var newPriceSpan = document.createElement('span');
                          newPriceSpan.className = 'boost-sd__cart-item-price-value';
                          newPriceSpan.style.fontSize = '12px';
                          newPriceSpan.textContent = price + '₺';
                          qtyPrice.appendChild(newPriceSpan);
                        }
                      }
                      var priceWrapper = newAddedItem.querySelector('.boost-sd__cart-item-quantity-price');
                      if (priceWrapper) {
                        priceWrapper.style.setProperty('white-space', 'nowrap', 'important');
                        priceWrapper.style.setProperty('margin-left', 'auto', 'important');
                        priceWrapper.style.setProperty('text-align', 'right', 'important');
                        priceWrapper.style.setProperty('flex', '0 0 auto', 'important');
                        priceWrapper.style.setProperty('font-size', '12px', 'important');
                      }
                      var qtyRow = newAddedItem.querySelector('.boost-sd__cart-item-quantity');
                      if (qtyRow) {
                        qtyRow.style.setProperty('display', 'flex', 'important');
                        qtyRow.style.setProperty('align-items', 'center', 'important');
                        qtyRow.style.setProperty('justify-content', 'space-between', 'important');
                        qtyRow.style.setProperty('width', '100%', 'important');
                        qtyRow.style.setProperty('flex-wrap', 'nowrap', 'important');
                      }
                      var inputNumber = newAddedItem.querySelector('.boost-sd__input-number');
                      if (inputNumber) {
                        inputNumber.style.setProperty('flex-shrink', '0', 'important');
                        inputNumber.style.setProperty('max-width', '100px', 'important');
                      }

                      // Miktarı 1 yap
                      var qtyInput = newAddedItem.querySelector('.boost-sd__input-number-input');
                      if (qtyInput) qtyInput.value = '1';

                      // Variant ID'leri güncelle
                      newAddedItem.querySelectorAll('[data-variant-id]').forEach(function(el) {
                        el.setAttribute('data-variant-id', variantId);
                      });

                      // İlk öğenin önüne ekle
                      existingItem.parentNode.insertBefore(newAddedItem, existingItem);
                    } else {
                      // Mevcut öğe yoksa fallback HTML kullan
                      var fallbackHtml =
                        '<div class="boost-sd__cart-item boost-sd__cart-item--added boost-sd__cart-item--custom" data-product-id="' + productId + '" data-variant-id="' + variantId + '" style="animation:boostFadeIn 0.3s ease;">' +
                          '<div class="boost-sd__cart-item-image">' +
                            '<a class="boost-sd__product-link" href="' + productUrl + '">' +
                              '<div class="boost-sd__product-image-wrapper boost-sd__product-image-wrapper--aspect-ratio-3-4">' +
                                '<div class="boost-sd__product-image">' +
                                  '<img class="boost-sd__product-image-img boost-sd__product-image-img--main" src="' + imgSrc + '" alt="' + title + '">' +
                                '</div>' +
                              '</div>' +
                            '</a>' +
                          '</div>' +
                          '<div class="boost-sd__cart-item-content">' +
                            '<div class="boost-sd__cart-item-info">' +
                              '<a class="boost-sd__product-link" href="' + productUrl + '">' +
                                '<div class="boost-sd__cart-item-title">' + title + '</div>' +
                              '</a>' +
                            '</div>' +
                            '<div class="boost-sd__cart-item-quantity" style="display:flex!important;align-items:center!important;justify-content:space-between!important;width:100%!important;flex-wrap:nowrap!important;">' +
                              '<div class="boost-sd__input-number boost-sd__input-number--sm" style="flex-shrink:0!important;max-width:100px!important;">' +
                                '<div class="boost-sd__input-number-btn-wrapper">' +
                                  '<button type="button" class="boost-sd__button boost-sd__button--full-width boost-sd__input-number-btn boost-sd__qty-decrease" data-variant-id="' + variantId + '"><span>-</span></button>' +
                                '</div>' +
                                '<div><input type="number" class="boost-sd__input-number-input" data-variant-id="' + variantId + '" value="1"></div>' +
                                '<div class="boost-sd__input-number-btn-wrapper">' +
                                  '<button type="button" class="boost-sd__button boost-sd__button--full-width boost-sd__input-number-btn boost-sd__qty-increase" data-variant-id="' + variantId + '"><span>+</span></button>' +
                                '</div>' +
                              '</div>' +
                              '<div class="boost-sd__cart-item-quantity-price" style="white-space:nowrap!important;margin-left:auto!important;text-align:right!important;flex:0 0 auto!important;font-size:12px!important;">' +
                                '<span class="boost-sd__cart-item-quantity-character">x</span>' +
                                '<span class="boost-sd__cart-item-price-value" style="font-size:12px!important;">' + price + '₺</span>' +
                              '</div>' +
                            '</div>' +
                          '</div>' +
                        '</div>';
                      cartBody.insertAdjacentHTML('afterbegin', fallbackHtml);
                      newAddedItem = cartBody.querySelector('.boost-sd__cart-item--added');
                    }
                    if (newAddedItem) {
                      var itemVariantId = variantId;
                      var unitPrice = actualPrice;

                      // Çöp butonu
                      var removeBtn = newAddedItem.querySelector('.boost-sd__cart-item-remove-btn');
                      if (removeBtn) {
                        removeBtn.addEventListener('click', function(e) {
                          e.preventDefault();
                          var vid = this.getAttribute('data-variant-id');
                          var itemEl = this.closest('.boost-sd__cart-item');

                          fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: vid, quantity: 0 })
                          })
                          .then(function(r) { return r.json(); })
                          .then(function(cartData) {
                            if (itemEl) {
                              itemEl.style.animation = 'boostFadeOut 0.3s ease';
                              setTimeout(function() { itemEl.remove(); }, 300);
                            }
                            var itemsCount = document.querySelector('.boost-sd__cart-items-count');
                            if (itemsCount) {
                              itemsCount.textContent = 'Sepetiniz (' + cartData.item_count + ' öğeler)';
                            }
                            if (window.Shopify && window.Shopify.pubsub && typeof PUB_SUB_EVENTS !== 'undefined') {
                              Shopify.pubsub.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cross-sell-remove', cartData: cartData });
                            }
                            setTimeout(function() { self.loadRecommendations(); }, 300);
                          });
                        });
                      }

                      // - butonu
                      var decreaseBtn = newAddedItem.querySelector('.boost-sd__qty-decrease');
                      if (decreaseBtn) {
                        decreaseBtn.addEventListener('click', function(e) {
                          e.preventDefault();
                          var vid = this.getAttribute('data-variant-id');
                          var itemEl = this.closest('.boost-sd__cart-item');
                          var input = itemEl.querySelector('.boost-sd__input-number-input');
                          var priceEl = itemEl.querySelector('.boost-sd__cart-item-price-value');
                          var currentQty = parseInt(input.value) || 1;
                          var newQty = Math.max(0, currentQty - 1);

                          if (newQty === 0) {
                            // Ürünü kaldır
                            fetch('/cart/change.js', {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: vid, quantity: 0 })
                            })
                            .then(function(r) { return r.json(); })
                            .then(function(cartData) {
                              itemEl.style.animation = 'boostFadeOut 0.3s ease';
                              setTimeout(function() { itemEl.remove(); }, 300);
                              var itemsCount = document.querySelector('.boost-sd__cart-items-count');
                              if (itemsCount) {
                                itemsCount.textContent = 'Sepetiniz (' + cartData.item_count + ' öğeler)';
                              }
                              if (window.Shopify && window.Shopify.pubsub && typeof PUB_SUB_EVENTS !== 'undefined') {
                                Shopify.pubsub.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cross-sell', cartData: cartData });
                              }
                            });
                          } else {
                            fetch('/cart/change.js', {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({ id: vid, quantity: newQty })
                            })
                            .then(function(r) { return r.json(); })
                            .then(function(cartData) {
                              input.value = newQty;
                              if (priceEl) {
                                var newPrice = (unitPrice * newQty / 100).toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                                priceEl.textContent = newPrice + '₺';
                              }
                              var itemsCount = document.querySelector('.boost-sd__cart-items-count');
                              if (itemsCount) {
                                itemsCount.textContent = 'Sepetiniz (' + cartData.item_count + ' öğeler)';
                              }
                            });
                          }
                        });
                      }

                      // + butonu
                      var increaseBtn = newAddedItem.querySelector('.boost-sd__qty-increase');
                      if (increaseBtn) {
                        increaseBtn.addEventListener('click', function(e) {
                          e.preventDefault();
                          var vid = this.getAttribute('data-variant-id');
                          var itemEl = this.closest('.boost-sd__cart-item');
                          var input = itemEl.querySelector('.boost-sd__input-number-input');
                          var priceEl = itemEl.querySelector('.boost-sd__cart-item-price-value');
                          var currentQty = parseInt(input.value) || 1;
                          var newQty = currentQty + 1;

                          fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: vid, quantity: newQty })
                          })
                          .then(function(r) { return r.json(); })
                          .then(function(cartData) {
                            input.value = newQty;
                            if (priceEl) {
                              var newPrice = (unitPrice * newQty / 100).toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                              priceEl.textContent = newPrice + '₺';
                            }
                            var itemsCount = document.querySelector('.boost-sd__cart-items-count');
                            if (itemsCount) {
                              itemsCount.textContent = 'Sepetiniz (' + cartData.item_count + ' öğeler)';
                            }
                          });
                        });
                      }

                      // Eklendi sınıfını kaldır
                      setTimeout(function() {
                        newAddedItem.classList.remove('boost-sd__cart-item--added');
                      }, 100);
                    }

                    // Sepet sayısını güncelle
                    var itemsCount = document.querySelector('.boost-sd__cart-items-count');
                    if (itemsCount) {
                      itemsCount.textContent = 'Sepetiniz (' + cart.item_count + ' öğeler)';
                    }
                  }

                  // Cross-sell'i yenile
                  if (typeof BoostCartCrossSell !== 'undefined') {
                    setTimeout(function() {
                      BoostCartCrossSell.loadRecommendations();
                    }, 300);
                  }
                });
            })
            .catch(function() {
              btn.style.background = '#dc3545';
              setTimeout(function() {
                btn.style.background = '#06683F';
                btn.style.transform = 'scale(1)';
              }, 500);
            });
          });

        }

        link.appendChild(imgWrapper);
        link.appendChild(info);
        card.appendChild(link);
        if (addBtn) card.appendChild(addBtn);
        slider.appendChild(card);
      });

      // Ok tıklama olayları
      var scrollAmount = cardWidth + 8;

      leftArrow.addEventListener('click', function(e) {
        e.preventDefault();
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      rightArrow.addEventListener('click', function(e) {
        e.preventDefault();
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      // Ok görünürlüğünü güncelle
      function updateArrows() {
        var scrollLeft = slider.scrollLeft;
        var maxScroll = slider.scrollWidth - slider.clientWidth;

        leftArrow.style.opacity = scrollLeft > 5 ? '1' : '0.4';
        rightArrow.style.opacity = scrollLeft < maxScroll - 5 ? '1' : '0.4';
      }

      slider.addEventListener('scroll', updateArrows);
      setTimeout(updateArrows, 100);

      wrapper.appendChild(slider);
      wrapper.appendChild(leftArrow);
      wrapper.appendChild(rightArrow);
      containerEl.appendChild(wrapper);

      // Resize'da kartları yeniden boyutlandır
      window.addEventListener('resize', function() {
        var newWidth = self.getCardWidth();
        var cards = containerEl.querySelectorAll('.boost-cs-card');
        cards.forEach(function(card) {
          card.style.flex = '0 0 ' + newWidth + 'px';
          card.style.minWidth = newWidth + 'px';
        });
        scrollAmount = newWidth + 8;
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { BoostCartCrossSell.init(); });
  } else {
    BoostCartCrossSell.init();
  }
})();

/* ---------------------------------------------------------------
   FİLTRE TEMİZLE BUTONU - MASAÜSTÜ TIKLAMA DÜZELTMESİ
   h1.yip-insert-title-text başlığı butonun üzerini kapatıyordu,
   CSS ile pointer-events: none yapıldı. Bu JS yedek olarak kalıyor.
   --------------------------------------------------------------- */
(function() {
  'use strict';

  var DESKTOP_BP = 750;

  function clearAllFilters() {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    var keysToRemove = [];

    params.forEach(function(value, key) {
      if (key.startsWith('pf_')) {
        keysToRemove.push(key);
      }
    });

    keysToRemove.forEach(function(key) {
      params.delete(key);
    });
    params.delete('page');

    var newUrl = url.pathname + (params.toString() ? '?' + params.toString() : '');
    window.location.href = newUrl;
  }

  // Masaüstünde filter clear butonuna tıklama
  document.addEventListener('click', function(e) {
    if (window.innerWidth < DESKTOP_BP) return;

    // Chip bar'ı hariç tut
    if (e.target.closest('#boost-tur-chip-bar')) return;

    // Filter clear butonunu bul
    var clearBtn = e.target.closest('.boost-sd__filter-option-title-clear');
    if (clearBtn) {
      e.preventDefault();
      e.stopPropagation();
      clearAllFilters();
    }
  }, true);

})();

/* ---------------------------------------------------------------
   BOOST RECOMMENDATION - İNDİRİMLİ FİYAT EKLEME
   Ürün detay sayfasındaki Boost öneri kartlarına compare_at_price ekler
   --------------------------------------------------------------- */
(function() {
  'use strict';

  var processedCards = new WeakSet();
  var priceCache = {};

  function getHandleFromUrl(url) {
    var match = url.match(/\/products\/([^\/\?#]+)/);
    return match ? match[1] : null;
  }

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + '₺';
  }

  function fetchProductPrice(handle) {
    if (priceCache[handle]) {
      return Promise.resolve(priceCache[handle]);
    }

    return fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.product && data.product.variants && data.product.variants[0]) {
          var v = data.product.variants[0];
          var price = Math.round(parseFloat(v.price) * 100);
          var compareAt = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
          var result = { price: price, compare_at_price: compareAt };
          priceCache[handle] = result;
          return result;
        }
        return null;
      })
      .catch(function() { return null; });
  }

  function updateCardPrice(card) {
    if (processedCards.has(card)) return;
    processedCards.add(card);

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    var handle = getHandleFromUrl(link.href);
    if (!handle) return;

    var priceEl = card.querySelector('.boost-sd__product-price-content, .boost-sd__product-price');
    if (!priceEl) return;

    // Zaten compare price varsa atla
    if (priceEl.querySelector('s, del, .boost-sd__product-price--compare')) return;

    fetchProductPrice(handle).then(function(data) {
      if (!data) return;
      if (!data.compare_at_price || data.compare_at_price <= data.price) return;

      // Mevcut fiyat elementini bul
      var currentPriceEl = priceEl.querySelector('.boost-sd__format-currency, span:not(s):not(del)');
      if (!currentPriceEl) return;

      // Container'ı flex column yap
      priceEl.style.cssText = 'display:flex !important;flex-direction:column !important;align-items:flex-start !important;gap:2px !important;';

      // Eski fiyat elementi oluştur
      var oldPriceEl = document.createElement('s');
      oldPriceEl.style.cssText = 'color:#000 !important;text-decoration:line-through !important;text-decoration-color:#c50d00 !important;font-size:inherit !important;font-weight:inherit !important;order:1 !important;';
      oldPriceEl.textContent = formatPrice(data.compare_at_price);

      // Mevcut fiyatı yeşil yap ve order ekle
      currentPriceEl.style.cssText = 'color:#49b187 !important;font-size:inherit !important;font-weight:inherit !important;order:2 !important;';

      // Eski fiyatı ekle
      priceEl.insertBefore(oldPriceEl, priceEl.firstChild);
    });
  }

  function processBoostWidgets() {
    var cards = document.querySelectorAll('.boost-sd__recommendation .boost-sd__product-item');
    cards.forEach(updateCardPrice);
  }

  // MutationObserver ile yeni kartları izle
  var observer = new MutationObserver(function(mutations) {
    var shouldProcess = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('boost-sd__product-item')) {
              shouldProcess = true;
            } else if (node.querySelector && node.querySelector('.boost-sd__product-item')) {
              shouldProcess = true;
            }
          }
        });
      }
    });
    if (shouldProcess) {
      setTimeout(processBoostWidgets, 100);
    }
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    // İlk yükleme için - performans optimizasyonu
    setTimeout(processBoostWidgets, 500);
    setTimeout(processBoostWidgets, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ===== İndirim rozetini Türkçe yüzde formatına çevir: "-25%" -> "%25" ===== */
(function () {
  'use strict';
  if (window.__trDiscountBadge) return;
  window.__trDiscountBadge = true;

  // "-25%", "25 %", "25,5 %" gibi metni "%25" biçimine çevirir.
  // Yüzde etiketi değilse ya da zaten "%.." ile başlıyorsa null döner (dokunma).
  function toTrPercent(text) {
    var t = (text || '').replace(/\s+/g, ' ').trim();
    if (!t || t.charAt(0) === '%') return null;
    // Baştaki eksi/artı (normal "-" ya da özel karakterler) opsiyonel.
    var m = t.match(/^[-−–—+]?\s*(\d+(?:[.,]\d+)?)\s*%$/);
    return m ? '%' + m[1] : null;
  }

  function localize(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    // Etiket metni span'ı
    scope.querySelectorAll('.boost-sd__product-label-text').forEach(function (el) {
      var v = toTrPercent(el.textContent);
      if (v && v !== el.textContent) el.textContent = v;
    });
    // span yoksa: doğrudan sale etiketinin içindeki metin
    scope.querySelectorAll('.boost-sd__product-label--sale').forEach(function (el) {
      if (el.querySelector('.boost-sd__product-label-text')) return;
      var v = toTrPercent(el.textContent);
      if (v && v !== el.textContent) el.textContent = v;
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      localize(document);
    });
  }

  function start() {
    localize(document);
    // Boost; filtre/sıralama/sayfalama sonrası ürün listesini yeniden çizer.
    // Yeni gelen rozetleri de yakalamak için DOM değişikliklerini izle.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------
   BOOST RECOMMENDATION ANALYTICS BRIDGE v2

   İki sorunu çözer:
   1) cartpage-686707/887768: Infinite loop klonlarındaki ATC
      butonları Boost'un event handler'larını kaybediyor.
      Çözüm: Klonlanmış buton tıklandığında, orijinal slide'daki
      karşılık gelen butona synthetic click göndererek Boost'un
      kendi handler'ının çalışmasını sağlar.
   2) cartpage-527251: Custom Cart Drawer Cross-Sell tamamen
      Boost dışında render ediliyor.
      Çözüm: ATC event'lerini Boost'un analytics event bus'ına
      ve SDK'sına ileterek tracking sağlar.
   --------------------------------------------------------------- */
(function() {
  'use strict';

  /* ---- Helpers ---- */
  function getWidgetId(el) {
    if (!el) return '';
    var walk = el.closest ? el : el.parentElement;
    while (walk) {
      // data-widget-id attribute
      var wid = walk.getAttribute && walk.getAttribute('data-widget-id');
      if (wid) return wid;
      // id içinde cartpage-XXXXX veya productpage-XXXXX
      var id = walk.id || '';
      var m = id.match(/((?:cartpage|productpage)-\d+)/);
      if (m) return m[1];
      walk = walk.parentElement;
    }
    return '';
  }

  function getProductInfo(el) {
    var item = el.closest('.boost-sd__product-item, .boost-sd__slide, .boost-cs-card');
    if (!item) return null;
    var link = item.querySelector('a[href*="/products/"]');
    var href = link ? (link.getAttribute('href') || '') : '';
    var handleMatch = href.match(/\/products\/([^\/\?#]+)/);
    var titleEl = item.querySelector('.boost-sd__product-title') || item.querySelector('p');
    return {
      handle: handleMatch ? handleMatch[1] : '',
      url: href,
      title: titleEl ? titleEl.textContent.trim() : ''
    };
  }

  /* ---- Fix 1: Tüm recommendation ATC tıklamalarını yakala ---- */
  // Hem orijinal hem klonlanmış butonlardaki ATC'leri yakalar.
  // Klonlarda: orijinal butona proxy click gönderir.
  // Tümünde: Boost analytics event'i fire eder.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.boost-sd__button--select-option, .boost-sd__button--add-to-cart');
    if (!btn) return;

    var rec = btn.closest('.boost-sd__recommendation');
    if (!rec) return;

    var widgetId = getWidgetId(rec);
    var info = getProductInfo(btn);

    // Boost context'ini set et
    window.__boostAtcContext = Date.now();

    // Klonlanmış slide ise → orijinal butona proxy
    var cloneSlide = btn.closest('.boost-infinite-clone');
    if (cloneSlide && info && info.url) {
      var originalSlides = rec.querySelectorAll('.slick-slide:not(.slick-cloned):not(.boost-infinite-clone)');
      for (var i = 0; i < originalSlides.length; i++) {
        var origLink = originalSlides[i].querySelector('a[href*="/products/"]');
        if (origLink && origLink.getAttribute('href') === info.url) {
          var origBtn = originalSlides[i].querySelector('.boost-sd__button--select-option, .boost-sd__button--add-to-cart');
          if (origBtn && origBtn !== btn) {
            origBtn.click();
            e.preventDefault();
            e.stopImmediatePropagation();
            var icon = btn.querySelector('.boost-sd__icon');
            if (icon) {
              icon.classList.add('adding-success');
              setTimeout(function() { icon.classList.remove('adding-success'); }, 2000);
            }
            return;
          }
        }
      }
    }

    // Tüm recommendation ATC'leri için analytics fire et
    if (widgetId && info) {
      setTimeout(function() {
        fireBoostAnalytics('add_to_cart', {
          widgetId: widgetId,
          productHandle: info.handle,
          productTitle: info.title
        });
      }, 500);
    }
  }, true); // capture phase

  /* ---- Fix 2: cartpage-527251 Custom Cross-Sell Analytics ---- */
  var CS_WIDGET_ID = 'cartpage-527251';

  // Impression tracking
  function trackCrossSellImpression() {
    var container = document.getElementById('BoostCartCrossSell');
    if (!container || container.dataset.boostImpressionTracked) return;

    var cards = container.querySelectorAll('.boost-cs-card');
    if (cards.length === 0) return;

    container.dataset.boostImpressionTracked = 'true';

    var handles = [];
    cards.forEach(function(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (link) {
        var m = (link.getAttribute('href') || '').match(/\/products\/([^\/\?#]+)/);
        if (m) handles.push(m[1]);
      }
    });

    fireBoostAnalytics('widget_view', {
      widgetId: CS_WIDGET_ID,
      products: handles
    });
  }

  // Cross-sell ATC butonlarını izle (event delegation)
  // NOT: closest() ile önce button'u, sonra container'ı ayrı kontrol et
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[data-variant-id]');
    if (!btn) return;
    // BoostCartCrossSell içinde mi kontrol et
    if (!btn.closest('#BoostCartCrossSell')) return;

    var url = btn.getAttribute('data-product-url') || '';
    var variantId = btn.getAttribute('data-variant-id') || '';

    window.__boostAtcContext = Date.now();

    // Gizli Boost widget'taki eşleşen butona proxy click gönder
    // Bu, Boost'un kendi analytics handler'ını tetikler
    var hiddenRec = document.querySelector('#boost-hidden-rec-527251 .boost-sd__recommendation');
    if (hiddenRec) {
      var hiddenBtns = hiddenRec.querySelectorAll('.boost-sd__button--select-option');
      for (var i = 0; i < hiddenBtns.length; i++) {
        if (hiddenBtns[i].getAttribute('data-product-url') === url ||
            hiddenBtns[i].getAttribute('data-variant-id') === variantId) {
          hiddenBtns[i].click();
          break;
        }
      }
    }

    setTimeout(function() {
      fireBoostAnalytics('add_to_cart', {
        widgetId: CS_WIDGET_ID,
        productHandle: url.match(/\/products\/([^\/\?#]+)/) ? url.match(/\/products\/([^\/\?#]+)/)[1] : '',
        variantId: variantId
      });
    }, 600);
  }, true);

  // Cross-sell render'ını izle - impression tracking
  var csObserver = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if ((node.id === 'BoostCartCrossSell') ||
            (node.querySelector && node.querySelector('#BoostCartCrossSell'))) {
          setTimeout(trackCrossSellImpression, 1000);
        }
        // Boost cart drawer açıldığında da kontrol et
        if (node.classList && (node.classList.contains('boost-sd__cart') ||
            node.classList.contains('boost-sd__cart--side'))) {
          setTimeout(trackCrossSellImpression, 1500);
        }
      }
    }
  });
  csObserver.observe(document.body, { childList: true, subtree: true });

  /* ---- Boost Analytics API Dispatcher ---- */
  function fireBoostAnalytics(eventType, data) {
    // 1) Custom event (diğer scriptler/Boost dinleyebilir)
    try {
      document.dispatchEvent(new CustomEvent('boost-sd:analytics', {
        bubbles: true,
        detail: Object.assign({ eventType: eventType }, data)
      }));
    } catch(e) {}

    // 2) Boost Widget Integration
    try {
      var wi = window.boostWidgetIntegration;
      if (wi && typeof wi.trackEvent === 'function') {
        wi.trackEvent(eventType, data);
      }
    } catch(e) {}

    // 3) Boost SD global analytics object
    try {
      var analytics = window.boostSDAnalytics ||
                      (window.boostSDAppConfig && window.boostSDAppConfig.analytics) ||
                      window.boostPFSAnalytics;
      if (analytics) {
        if (typeof analytics.track === 'function') {
          analytics.track(eventType, data);
        }
        if (eventType === 'add_to_cart' && typeof analytics.trackAddToCart === 'function') {
          analytics.trackAddToCart(data);
        }
        if (eventType === 'widget_view' && typeof analytics.trackView === 'function') {
          analytics.trackView(data);
        }
      }
    } catch(e) {}

    // 4) Boost'un recommendation scope'una re-render tetikle
    try {
      var wi = window.boostWidgetIntegration;
      if (wi && typeof wi.regisCustomization === 'function') {
        // Boost'un recommendation hook'larını yeniden çalıştır
        // Bu, analytics binding'i yenilemesini sağlayabilir
        if (eventType === 'widget_view') {
          wi.regisCustomization(function() {}, 'recommendation');
        }
      }
    } catch(e) {}
  }

})();